/* Hospital at Home — Arabic dictionary.
 * Comprehensive EN -> AR map for visible UI strings.
 * Add new entries as features evolve; missing keys fall back to English. */

export const AR = {
  // ── Brand / Shell ──────────────────────────────────────────
  "Hospital at Home": "المستشفى في المنزل",
  "Care Beyond Walls": "رعاية بلا حدود",
  "Hospital @ Home": "المستشفى في المنزل",
  "Admin Console": "لوحة المسؤول",
  "Care Beyond walls": "رعاية بلا حدود",
  "Workspace": "مساحة العمل",
  "Home": "الرئيسية",
  "Search patients, users, facilities…": "ابحث عن المرضى والمستخدمين والمنشآت…",
  "All Facilities": "جميع المنشآت",
  "Facility scope": "نطاق المنشأة",
  "Select": "اختر",
  "Sign out": "تسجيل الخروج",
  "Sign in": "تسجيل الدخول",
  "Signing in…": "جاري تسجيل الدخول…",
  "Welcome back": "مرحباً بعودتك",
  "Use your H@H administrator credentials to continue.": "استخدم بيانات مسؤول H@H للمتابعة.",
  "Work email": "البريد الإلكتروني للعمل",
  "Password": "كلمة المرور",
  "Demo accounts": "حسابات تجريبية",
  "Click a card to autofill credentials, then press": "اضغط على البطاقة لتعبئة البيانات تلقائياً ثم اضغط",
  "System Admin": "مسؤول النظام",
  "H@H Physician": "طبيب H@H",
  "Nurse (Hotline)": "ممرض (الخط الساخن)",
  "H@H Care Coordinator": "منسق الرعاية H@H",
  "Hospital Coordinator": "منسق المستشفى",
  "Home Care Team": "فريق الرعاية المنزلية",
  "System operational": "النظام يعمل",
  "Command Center": "مركز القيادة",
  "Run hospital-at-home care with clinical precision.": "أدر رعاية المستشفى في المنزل بدقة سريرية.",
  "Unified administration for patients, clinicians, facilities, and audit — the foundation for your entire H@H ecosystem.":
    "إدارة موحّدة للمرضى والأطباء والمنشآت وسجلات التدقيق — أساس منظومة H@H الكاملة.",
  "Patient Ops": "عمليات المرضى",
  "Roles & Audit": "الأدوار والتدقيق",
  "Facility Network": "شبكة المنشآت",
  "Hospital at Home Platform": "منصة المستشفى في المنزل",
  "Loading…": "جاري التحميل…",
  "User": "مستخدم",

  // ── Sidebar nav ────────────────────────────────────────────
  "Dashboard": "لوحة التحكم",
  "User Management": "إدارة المستخدمين",
  "Patient Management": "إدارة المرضى",
  "Facility Management": "إدارة المنشآت",
  "Roles & Permissions": "الأدوار والصلاحيات",
  "Lookups": "القوائم المرجعية",
  "Clinical Protocols": "البروتوكولات السريرية",
  "RPM Thresholds": "حدود المراقبة عن بُعد",
  "Reports & Exports": "التقارير والتصدير",
  "Audit Trail": "سجل التدقيق",

  "RPM Command Center": "مركز قيادة المراقبة عن بُعد",
  "Active Alerts": "التنبيهات النشطة",
  "Interventions": "التدخلات",

  "Fleet Command Center": "مركز قيادة الأسطول",
  "Fleet Dashboard": "لوحة الأسطول",
  "Live Operations Map": "خريطة العمليات الحية",
  "Visit Board": "لوحة الزيارات",
  "Clinicians": "الأطباء",
  "Vehicles": "المركبات",

  "Teleconsultation": "الاستشارة عن بُعد",
  "Consultations": "الاستشارات",

  "Clinical Operations": "العمليات السريرية",
  "Active Patients": "المرضى النشطون",
  "My Patients": "مرضاي",
  "High-Risk Patients": "المرضى ذوو الخطورة العالية",
  "RPM Escalations": "تصعيدات المراقبة",
  "Hotline Follow-Ups": "متابعات الخط الساخن",
  "Upcoming Teleconsultations": "الاستشارات القادمة",
  "Home Visits": "الزيارات المنزلية",
  "Clinical Tasks": "المهام السريرية",

  "Executive Dashboard": "اللوحة التنفيذية",
  "Operational Dashboard": "اللوحة التشغيلية",
  "Clinical Safety": "السلامة السريرية",
  "Population Health": "صحة السكان",
  "Active Interventions": "التدخلات النشطة",
  "SLA Manager": "إدارة SLA",
  "Patient Explorer": "مستكشف المرضى",
  "Reports": "التقارير",

  "Hospital Workspace": "مساحة عمل المستشفى",
  "Onboarding Dashboard": "لوحة استقبال المرضى",
  "Create Request": "إنشاء طلب",
  "My Requests": "طلباتي",
  "Drafts": "المسودات",
  "Information Requested": "معلومات مطلوبة",
  "Rejected": "مرفوض",
  "Completed": "مكتمل",

  "H@H Operations": "عمليات H@H",
  "Medical Review Queue": "قائمة المراجعة الطبية",
  "Assessment Queue": "قائمة التقييم",
  "Awaiting Assignment": "بانتظار التعيين",
  "Assigned Visits": "زيارات معيّنة",
  "Visit Findings": "نتائج الزيارة",

  "Field Workspace": "مساحة العمل الميدانية",
  "Visits Dashboard": "لوحة الزيارات",
  "In Progress": "قيد التنفيذ",
  "Completed Visits": "زيارات مكتملة",

  "Nurse Hotline": "الخط الساخن للممرضين",
  "Hotline Dashboard": "لوحة الخط الساخن",
  "New Hotline Session": "جلسة جديدة",
  "Active Sessions": "جلسات نشطة",
  "Decision Pending": "بانتظار القرار",
  "Escalated": "مصعَّد",
  "Follow-Up Required": "بحاجة متابعة",
  "Closed Sessions": "جلسات مغلقة",

  // ── Page headers / subtitles ───────────────────────────────
  "System Admin Command Center": "مركز قيادة مسؤول النظام",
  "What's happening across the Hospital @ Home network — right now.":
    "ما يحدث الآن عبر شبكة المستشفى في المنزل.",
  "Total Users": "إجمالي المستخدمين",
  "Active Patients ": "المرضى النشطون",
  "Facilities": "المنشآت",
  "Audit Events Today": "أحداث التدقيق اليوم",
  "Active Users": "المستخدمون النشطون",
  "Total Roles": "إجمالي الأدوار",
  "Lookup Categories": "فئات القوائم المرجعية",
  "Total Patients": "إجمالي المرضى",
  "Trends": "الاتجاهات",
  "Audit events — last 7 days": "أحداث التدقيق — آخر 7 أيام",
  "Workforce": "القوى العاملة",
  "User distribution by role": "توزيع المستخدمين حسب الدور",
  "Live": "مباشر",
  "Last 24 hours": "آخر 24 ساعة",
  "active": "نشط",
  "of": "من",
  "total": "إجمالي",
  "operational": "تعمل",

  "Immutable record of every action across the Hospital @ Home platform.":
    "سجل غير قابل للتعديل لكل إجراء على منصة المستشفى في المنزل.",
  "Hospital @ Home Command Center": "مركز قيادة المستشفى في المنزل",
  "Real-time operational and clinical intelligence":
    "ذكاء تشغيلي وسريري في الوقت الفعلي",

  // ── Common buttons / labels ────────────────────────────────
  "Save": "حفظ",
  "Cancel": "إلغاء",
  "Delete": "حذف",
  "Edit": "تعديل",
  "Create": "إنشاء",
  "Add": "إضافة",
  "Remove": "إزالة",
  "Update": "تحديث",
  "Submit": "إرسال",
  "Close": "إغلاق",
  "Confirm": "تأكيد",
  "Back": "رجوع",
  "Next": "التالي",
  "Previous": "السابق",
  "Search": "بحث",
  "Filter": "تصفية",
  "Clear": "مسح",
  "Reset": "إعادة تعيين",
  "Apply": "تطبيق",
  "View": "عرض",
  "View All": "عرض الكل",
  "Refresh": "تحديث",
  "Export": "تصدير",
  "Download": "تنزيل",
  "Upload": "رفع",
  "Loading": "جاري التحميل",
  "No data": "لا توجد بيانات",
  "No results": "لا توجد نتائج",
  "Yes": "نعم",
  "No": "لا",
  "Active": "نشط",
  "Inactive": "غير نشط",
  "Status": "الحالة",
  "Type": "النوع",
  "Name": "الاسم",
  "Email": "البريد الإلكتروني",
  "Phone": "الهاتف",
  "Role": "الدور",
  "Created": "تم الإنشاء",
  "Updated": "تم التحديث",
  "Actions": "الإجراءات",
  "Details": "التفاصيل",
  "Overview": "نظرة عامة",
  "Settings": "الإعدادات",
  "Profile": "الملف الشخصي",
  "Notifications": "الإشعارات",
  "Help": "مساعدة",
  "Logout": "تسجيل الخروج",
  "Sign in to continue": "سجّل الدخول للمتابعة",
  "Required": "مطلوب",
  "Optional": "اختياري",
  "Save changes": "حفظ التغييرات",
  "Discard": "تجاهل",
  "All": "الكل",
  "None": "لا شيء",
  "Today": "اليوم",
  "Yesterday": "أمس",
  "This Week": "هذا الأسبوع",
  "This Month": "هذا الشهر",
  "Last 7 days": "آخر 7 أيام",
  "Last 30 days": "آخر 30 يوم",

  // ── Status / Clinical ──────────────────────────────────────
  "Draft": "مسودة",
  "Submitted": "تم الإرسال",
  "Pending": "قيد الانتظار",
  "Approved": "مُعتمد",
  "Under Review": "قيد المراجعة",
  "Critical": "حرج",
  "High Risk": "عالي الخطورة",
  "Stable": "مستقر",
  "Improving": "في تحسّن",
  "Deteriorating": "في تدهور",
  "Patient": "المريض",
  "Patients": "المرضى",
  "Diagnosis": "التشخيص",
  "Medications": "الأدوية",
  "Vitals": "العلامات الحيوية",
  "Notes": "الملاحظات",
  "Orders": "الأوامر الطبية",
  "MAR": "سجل إعطاء الأدوية",
  "Progress Notes": "ملاحظات التقدم",
  "Care Plan": "خطة الرعاية",
  "Admission": "القبول",
  "Discharge": "الخروج",
  "Visit": "زيارة",
  "Visits": "زيارات",
  "Appointment": "موعد",
  "Appointments": "المواعيد",
  "Schedule": "الجدول",
  "Today's Schedule": "جدول اليوم",
  "Severity": "الشدّة",
  "Priority": "الأولوية",
  "High": "عالي",
  "Medium": "متوسط",
  "Low": "منخفض",

  // ── Auth / Errors ──────────────────────────────────────────
  "Invalid credentials": "بيانات اعتماد غير صحيحة",
  "Login failed": "فشل تسجيل الدخول",
  "Session expired": "انتهت الجلسة",
  "Access denied": "تم رفض الوصول",
  "Something went wrong": "حدث خطأ ما",
  "Try again": "حاول مرة أخرى",
  "Saved": "تم الحفظ",
  "Created successfully": "تم الإنشاء بنجاح",
  "Updated successfully": "تم التحديث بنجاح",
  "Deleted successfully": "تم الحذف بنجاح",

  // ── Header / Misc ──────────────────────────────────────────
  "Switch to dark mode": "التبديل للوضع الداكن",
  "Switch to light mode": "التبديل للوضع الفاتح",
  "Language": "اللغة",
  "Theme": "المظهر",
  "Light": "فاتح",
  "Dark": "داكن",
  "English": "الإنجليزية",
  "Arabic": "العربية",
  "العربية": "العربية",

  // ── Page titles ────────────────────────────────────────────
  "Clinical Command Center": "مركز القيادة السريرية",
  "Nurse Hotline Command Center": "مركز قيادة الخط الساخن",
  "Onboarding Command Center": "مركز قيادة استقبال المرضى",
  "Onboarding Requests": "طلبات الاستقبال",
  "Population Health Dashboard": "لوحة صحة السكان",
  "RPM Active Alerts": "تنبيهات المراقبة النشطة",
  "RPM SLA": "SLA المراقبة",
  "RPM Interventions": "تدخلات المراقبة",
  "RPM Vital Thresholds": "حدود العلامات الحيوية",
  "Hotline SLA": "SLA الخط الساخن",
  "Onboarding SLA": "SLA الاستقبال",
  "Teleconsult SLA": "SLA الاستشارة",
  "Hotline Sessions": "جلسات الخط الساخن",
  "Lookups Management": "إدارة القوائم المرجعية",
  "Vehicle Management": "إدارة المركبات",
  "Visit Scheduling Board": "لوحة جدولة الزيارات",
  "Active Sessions Queue": "قائمة الجلسات النشطة",
  "Escalation Queue": "قائمة التصعيد",
  "Follow-Up Queue": "قائمة المتابعة",
  "Clinician Availability": "توفر الأطباء",
  "Command Center Reports": "تقارير مركز القيادة",
  "Configuration": "الإعداد",
  "Performance": "الأداء",
  "Protocol Execution": "تنفيذ البروتوكول",
  "Protocol metadata": "بيانات البروتوكول",
  "Service Configuration": "إعداد الخدمة",
  "Patient Identification": "تعريف المريض",
  "Patient Information": "معلومات المريض",
  "General Information": "معلومات عامة",
  "Clinical Information": "المعلومات السريرية",
  "Service Information": "معلومات الخدمة",
  "Referral Information": "معلومات الإحالة",
  "Audit Information": "معلومات التدقيق",
  "Value details": "تفاصيل القيمة",
  "Verification": "التحقق",
  "Assignment": "التعيين",
  "Assessment": "التقييم",
  "Chief Complaint": "الشكوى الرئيسية",
  "Add intervention": "إضافة تدخل",
  "Acknowledge alerts": "إقرار التنبيهات",
  "Notes & evidence": "الملاحظات والأدلة",
  "Session attachments": "مرفقات الجلسة",
  "Fleet": "الأسطول",

  // ── Subtitles ──────────────────────────────────────────────
  "All clinical actions recorded against monitored patients.": "جميع الإجراءات السريرية المسجلة على المرضى تحت المراقبة.",
  "Census, care team assignment, and patient lifecycle across the network.": "الإحصاء وتعيين فريق الرعاية ودورة حياة المريض عبر الشبكة.",
  "Cohort analysis and population insights": "تحليل الأفواج ورؤى السكان",
  "Configurable decision trees that nurses follow during hotline triage.": "أشجار قرار قابلة للتهيئة يتبعها الممرضون أثناء فرز الخط الساخن.",
  "Configure role-based access and clone permission templates.": "هيّئ الوصول حسب الأدوار وانسخ قوالب الصلاحيات.",
  "Download operational reports in CSV, Excel (.xlsx) or PDF formats.": "حمّل التقارير التشغيلية بصيغ CSV أو Excel أو PDF.",
  "Fleet vehicle registry — admin-managed.": "سجل مركبات الأسطول — تُدار من قبل المسؤول.",
  "H@H hubs, service configurations, and coverage areas.": "مراكز H@H وإعدادات الخدمات ومناطق التغطية.",
  "Live across RPM, Hotline, Teleconsult, Home Visits, Orders": "مباشر عبر المراقبة والخط الساخن والاستشارة والزيارات المنزلية والأوامر",
  "Live readiness, workload and capacity for all field clinicians.": "الجاهزية وعبء العمل والسعة المباشرة لجميع الأطباء الميدانيين.",
  "Manage clinicians, administrators, and staff across the H@H network.": "إدارة الأطباء والمسؤولين والموظفين عبر شبكة H@H.",
  "Real-time clinical overview and patient safety monitoring": "نظرة سريرية فورية ومراقبة سلامة المرضى",
  "Real-time monitoring of active H@H patients · auto-refresh every 30s": "مراقبة آنية لمرضى H@H النشطين · تحديث تلقائي كل 30 ثانية",
  "Real-time operational view of clinicians, visits, and vehicles.": "عرض تشغيلي آني للأطباء والزيارات والمركبات.",
  "Reference data, picklists, and configurable enumerations across the platform.": "البيانات المرجعية والقوائم المنسدلة عبر المنصة.",
  "Scheduled tasks": "المهام المجدولة",
  "Snapshot exports of every dashboard": "صور تصدير لكل لوحة",
  "Threshold breaches, NEWS2, AI deterioration, missing-reading and device alerts.": "تجاوزات الحدود وNEWS2 وتدهور الذكاء الاصطناعي والقراءات المفقودة وتنبيهات الأجهزة.",
  "Triage / dispatch": "الفرز / الإرسال",
  "Unified view across RPM, Hotline, Teleconsultations and Home Visits.": "عرض موحّد عبر المراقبة والخط الساخن والاستشارات والزيارات.",
  "Virtual care sessions across the H@H ecosystem.": "جلسات الرعاية الافتراضية عبر منظومة H@H.",
  "Visits sourced from Onboarding, RPM, Hotline and manual requests.": "زيارات مصدرها الاستقبال والمراقبة والخط الساخن والطلبات اليدوية.",
  "What needs attention": "ما يحتاج إلى اهتمام",
  "Workflow funnels, bottlenecks and SLA visibility": "قنوات العمل والاختناقات ووضوح SLA",
  "Workflow performance across modules": "أداء سير العمل عبر الوحدات",

  // ── Forms / labels ─────────────────────────────────────────
  "First name": "الاسم الأول",
  "Last name": "اسم العائلة",
  "Mobile number": "رقم الجوال",
  "Mobile": "الجوال",
  "Initial password": "كلمة المرور الأولية",
  "Last login": "آخر تسجيل دخول",
  "DOB": "تاريخ الميلاد",
  "Date of birth": "تاريخ الميلاد",
  "Gender": "الجنس",
  "Nationality": "الجنسية",
  "National ID": "الهوية الوطنية",
  "National ID / Iqama": "الهوية الوطنية / الإقامة",
  "MRN": "رقم الملف الطبي",
  "Address": "العنوان",
  "City": "المدينة",
  "State": "المنطقة",
  "Code": "الرمز",
  "Description": "الوصف",
  "Label": "التسمية",
  "Category": "الفئة",
  "Sort order": "ترتيب العرض",
  "Department": "القسم",
  "Source": "المصدر",
  "Scope": "النطاق",
  "Reason": "السبب",
  "Comments": "تعليقات",
  "Outcome": "النتيجة",
  "Plan": "الخطة",
  "Recommendations": "التوصيات",
  "Recommendation note (optional)": "ملاحظة التوصية (اختيارية)",
  "Symptoms": "الأعراض",
  "Symptom duration": "مدة الأعراض",
  "Frequency": "التكرار",
  "Dose": "الجرعة",
  "Dose Given": "الجرعة المُعطاة",
  "Route": "المسار",
  "PRN": "عند الحاجة",
  "Medication": "الدواء",
  "Current medications": "الأدوية الحالية",
  "Allergies": "الحساسية",
  "Primary diagnosis": "التشخيص الأساسي",
  "Secondary diagnosis": "التشخيص الثانوي",
  "Chronic Conditions": "الحالات المزمنة",
  "Clinical notes": "ملاحظات سريرية",
  "Clinical observations": "ملاحظات سريرية",
  "Clinical summary": "الملخص السريري",
  "Clinical Indication": "الإشارة السريرية",
  "Clinical justification": "التبرير السريري",
  "Nurse notes": "ملاحظات الممرض",
  "Follow-up notes": "ملاحظات المتابعة",
  "Additional notes": "ملاحظات إضافية",
  "Additional findings": "نتائج إضافية",
  "Patient responses": "ردود المريض",
  "Selected patient": "المريض المختار",
  "Patient type": "نوع المريض",
  "Override reason": "سبب التجاوز",
  "Suggested decision": "القرار المقترح",
  "Decision": "القرار",
  "Order Type": "نوع الأمر",
  "Subjective": "ذاتي",
  "Objective": "موضوعي",
  "Narrative": "السرد",
  "Captured at": "تم التسجيل في",
  "Last updated": "آخر تحديث",
  "Last maintenance (YYYY-MM-DD)": "آخر صيانة (YYYY-MM-DD)",
  "Insurance expiry (YYYY-MM-DD)": "انتهاء التأمين (YYYY-MM-DD)",
  "Scheduled at (ISO)": "موعد محدد",
  "Expected start": "البدء المتوقع",
  "Expected start date": "تاريخ البدء المتوقع",
  "Referral date": "تاريخ الإحالة",
  "Referral facility": "منشأة الإحالة",
  "Referral source": "مصدر الإحالة",
  "Referring physician": "الطبيب المُحيل",
  "Requested service": "الخدمة المطلوبة",
  "Admission date": "تاريخ القبول",
  "Consultation Type": "نوع الاستشارة",
  "Complaint category": "فئة الشكوى",
  "Protocol category": "فئة البروتوكول",
  "Available protocols": "البروتوكولات المتاحة",
  "Site / Route Notes": "ملاحظات الموقع / المسار",
  "Primary Provider": "مقدم الرعاية الرئيسي",
  "Team lead": "قائد الفريق",
  "Team lead ID": "رقم قائد الفريق",
  "Team": "الفريق",
  "Coverage areas (comma separated)": "مناطق التغطية (مفصولة بفواصل)",
  "Services (comma separated)": "الخدمات (مفصولة بفواصل)",
  "Plate number": "رقم اللوحة",
  "Test Name": "اسم الفحص",
  "Date & Time": "التاريخ والوقت",
  "Due Date": "تاريخ الاستحقاق",
  "Duration": "المدة",
  "Duration (days)": "المدة (أيام)",
  "Duration (min)": "المدة (دقائق)",
  "Avg Age (Years)": "متوسط العمر (سنة)",
  "Avg Duration": "متوسط المدة",
  "Avg Duration (min)": "متوسط المدة (دقائق)",
  "Avg Handling Time (min)": "متوسط وقت المعالجة (دقائق)",
  "Avg Onboarding Time": "متوسط وقت الاستقبال",
  "Avg Travel": "متوسط التنقل",
  "Avg Visit": "متوسط الزيارة",
  "Action": "الإجراء",
  "Entity": "الكيان",
  "Entity ID": "معرّف الكيان",
  "Record ID": "معرّف السجل",
  "Assignee": "المُكلَّف",
  "Assign to Physician (optional)": "تعيين لطبيب (اختياري)",
  "Target": "الهدف",

  // ── KPIs / Status labels ───────────────────────────────────
  "AI Acceptance": "قبول الذكاء الاصطناعي",
  "AI Deterioration": "تدهور الذكاء الاصطناعي",
  "Abnormal Now": "غير طبيعي الآن",
  "Assigned": "مُعيَّن",
  "Available": "متاح",
  "Busy": "مشغول",
  "Calls Today": "المكالمات اليوم",
  "Cancelled": "ملغى",
  "Closure %": "نسبة الإغلاق %",
  "Closure Rate": "معدّل الإغلاق",
  "Completed Today": "اكتمل اليوم",
  "Completion Rate": "معدّل الإنجاز",
  "Coordinators": "المنسقون",
  "Critical / Urgent": "حرج / عاجل",
  "Critical Alerts": "تنبيهات حرجة",
  "Delayed": "متأخر",
  "Device Issues": "مشاكل الأجهزة",
  "Discharges": "حالات الخروج",
  "En Route": "في الطريق",
  "Escalated Cases": "حالات مُصعَّدة",
  "Escalation %": "نسبة التصعيد %",
  "Facility": "المنشأة",
  "Female Patients": "المريضات",
  "Follow-Ups": "متابعات",
  "Go to next page": "الذهاب للصفحة التالية",
  "Go to previous page": "الذهاب للصفحة السابقة",
  "High NEWS2": "NEWS2 مرتفع",
  "High Risk Patients": "مرضى عاليي الخطورة",
  "Home Care Teams": "فرق الرعاية المنزلية",
  "Home Visits Today": "زيارات منزلية اليوم",
  "Hotline Calls Today": "مكالمات الخط الساخن اليوم",
  "Hotline Escalated": "تصعيد الخط الساخن",
  "Maintenance": "صيانة",
  "Mine": "خاصتي",
  "Missing Readings": "قراءات مفقودة",
  "Moderate Risk": "خطورة متوسطة",
  "Moderate": "متوسط",
  "New Activations": "تفعيلات جديدة",
  "New Admissions": "قبولات جديدة",
  "No Show Rate": "معدل عدم الحضور",
  "No Show": "لم يحضر",
  "No-Show": "لم يحضر",
  "Nurses": "الممرضون",
  "Offline": "غير متصل",
  "On-Time Performance": "الأداء في الوقت المحدد",
  "Open": "مفتوح",
  "Overdue": "متأخر",
  "Physicians": "الأطباء",
  "RPM Enrolled": "مسجَّل في المراقبة",
  "RPM Escalated": "مُصعَّد للمراقبة",
  "Readmission Rate": "معدّل إعادة القبول",
  "Ready": "جاهز",
  "Rejected Referrals": "إحالات مرفوضة",
  "SLA At-Risk": "SLA معرّض للخطر",
  "SLA Breaches": "خروقات SLA",
  "SLA Compliance": "الالتزام بـ SLA",
  "SLA at risk": "SLA معرّض للخطر",
  "Teleconsult": "استشارة عن بُعد",
  "Teleconsults Today": "استشارات اليوم",
  "RPM": "المراقبة عن بُعد",

  // ── Common UI ──────────────────────────────────────────────
  "No recent activity.": "لا يوجد نشاط حديث.",
  "No audit events.": "لا توجد أحداث تدقيق.",
  "Loading dashboard data…": "جاري تحميل بيانات اللوحة…",
  "Recent activities": "الأنشطة الأخيرة",
  "Latest audit log": "أحدث سجل تدقيق",
  "Activity feed": "تغذية الأنشطة",
  "Compliance": "الامتثال",
  "Network": "الشبكة",
  "Facility distribution": "توزيع المنشآت",
  "Operational queue": "قائمة العمليات",
  "System health": "صحة النظام",
  "What will happen next": "ما سيحدث بعد",
  "Locked user accounts": "حسابات مستخدمين مقفلة",
  "Inactive facilities": "منشآت غير نشطة",
  "Patients discharged today": "مرضى تم تخريجهم اليوم",
  "Time": "الوقت",
  "By": "بواسطة",
  "system": "النظام",
  "user": "مستخدم",

  // ── Misc ───────────────────────────────────────────────────
  "Admin": "مسؤول",
  "Onboarding": "الاستقبال",
  "Requests": "الطلبات",
  "New Request": "طلب جديد",

  // ── Home Care Team Assignment (nurse + H@H technician) ──────
  "Assign Home Care Team": "تعيين فريق الرعاية المنزلية",
  "Assign at least one nurse and one H@H technician. Availability for the selected day is shown — you can still override and assign.": "عيّن ممرضاً واحداً وفنياً واحداً على الأقل من H@H. يظهر التوفر لليوم المحدد — ويمكنك التجاوز والتعيين.",
  "Visit schedule": "جدول الزيارة",
  "Visit date": "تاريخ الزيارة",
  "Visit time": "وقت الزيارة",
  "Nurses (≥ 1 required)": "الممرضون (مطلوب ١ على الأقل)",
  "H@H Technicians (≥ 1 required)": "فنيو H@H (مطلوب ١ على الأقل)",
  "Double-booking warning": "تحذير من الحجز المزدوج",
  "You can still proceed — they'll be assigned anyway.": "لا يزال بإمكانك المتابعة — سيتم تعيينهم على أي حال.",
  "Confirm assignment": "تأكيد التعيين",
  "Assigning…": "جاري التعيين…",
  "Home care team": "فريق الرعاية المنزلية",
  "H@H Technicians": "فنيو H@H",
  "H@H Technician": "فني H@H",

  // ── Care Team tab (read-only roster) ───────────────────────
  "Care Roster": "قائمة فريق الرعاية",
  "The responsible care team is set by the physician's Care Plan and the onboarding assignment.": "يتم تحديد فريق الرعاية المسؤول من خلال خطة الرعاية الخاصة بالطبيب وتعيين الاستقبال.",
  "No care team members assigned yet.": "لم يتم تعيين أعضاء فريق رعاية بعد.",

  // ── Onboarding referral facility lock ──────────────────────
  "Auto-set to your facility — referrals are created under the facility you work in.": "يتم ضبطه تلقائياً على منشأتك — يتم إنشاء الإحالات ضمن المنشأة التي تعمل بها.",

  // ── My Profile module ──────────────────────────────────────
  "My Profile": "ملفي الشخصي",
  "Applied across the platform whenever you sign in.": "يُطبّق عبر المنصة في كل مرة تسجّل الدخول.",
  "Choose light or dark appearance.": "اختر المظهر الفاتح أو الداكن.",
  "At least 8 characters, including a letter and a number.": "ما لا يقل عن ٨ أحرف، بما في ذلك حرف ورقم.",
  "Preference saved": "تم حفظ التفضيل",
  "Profile updated": "تم تحديث الملف الشخصي",
  "Password updated": "تم تحديث كلمة المرور",
  "Availability saved": "تم حفظ التوفر",
  "Set the hours you're available for teleconsultations. Patients can book 30-minute slots within these windows.": "حدّد الساعات المتاحة للاستشارات عن بُعد. يمكن للمرضى حجز فترات مدتها ٣٠ دقيقة ضمن هذه النوافذ.",
  "Block a day off or set special hours for a specific date.": "احجب يوم إجازة أو حدّد ساعات خاصة لتاريخ معيّن.",
  "Availability": "التوفر",
  "Title": "المسمى",
  "Preferences": "التفضيلات",
  "Security": "الأمان",
  "Manage your details, preferences, availability and reviews.": "إدارة بياناتك وتفضيلاتك وتوفرك وتقييماتك.",
  "Personal information": "المعلومات الشخصية",
  "Email (read-only)": "البريد الإلكتروني (للقراءة فقط)",
  "Role (read-only)": "الدور (للقراءة فقط)",
  "Default language": "اللغة الافتراضية",
  "light": "فاتح",
  "dark": "داكن",
  "Change password": "تغيير كلمة المرور",
  "New password": "كلمة المرور الجديدة",
  "Confirm new password": "تأكيد كلمة المرور الجديدة",
  "Update password": "تحديث كلمة المرور",
  "Weekly availability": "التوفر الأسبوعي",
  "Add window": "إضافة فترة",
  "Add date": "إضافة تاريخ",
  "Date-specific overrides": "استثناءات خاصة بتاريخ",
  "Save availability": "حفظ التوفر",
  "Available slots": "الفترات المتاحة",
  "Open slots": "الفترات المتاحة",
  "Booked": "محجوز",
  "No availability on this day.": "لا يوجد توفر في هذا اليوم.",
  "Rating breakdown": "تفصيل التقييم",
  "Recent feedback": "أحدث التقييمات",
  "Teleconsultation Availability": "توفر الاستشارة عن بُعد",
  "Teleconsult Availability": "توفر الاستشارة عن بُعد",
  "Clinician": "الطبيب/الممرض",

  // ── Sidebar / system-feature labels ────────────────────────
  "male": "ذكر",
  "female": "أنثى",
  "Male": "ذكر",
  "Female": "أنثى",
  "Access Control": "التحكم في الوصول",
  "Care Plans": "خطط الرعاية",
  "Form Builder": "منشئ النماذج",
  "My Submissions": "طلباتي",
  "SMS Console": "وحدة الرسائل النصية",
  "Fleet Operations": "عمليات الأسطول",

  // ── Form Builder publish state ─────────────────────────────
  "Publish": "نشر",
  "Publish changes": "نشر التغييرات",
  "Published": "منشور",
  "● Unpublished changes — not live yet": "● تغييرات غير منشورة — غير مفعّلة بعد",

  // ── Auto-translated UI strings (system-wide sweep) ──────────
  "24 Hours": "24 ساعة",
  "30 Days": "30 يومًا",
  "48 Hours": "48 ساعة",
  "7 Days": "7 أيام",
  "A justification is required.": "المبرر مطلوب.",
  "AI Assign": "تعيين بالذكاء الاصطناعي",
  "AI Clinician Recommendations": "توصيات الذكاء الاصطناعي للأطباء",
  "AI Deterioration Risk": "مخاطر التدهور بالذكاء الاصطناعي",
  "AI Recommendations": "توصيات الذكاء الاصطناعي",
  "AI Risk": "مخاطر الذكاء الاصطناعي",
  "AI Risk:": "مخاطر الذكاء الاصطناعي:",
  "AI Route Acceptance": "قبول المسار بالذكاء الاصطناعي",
  "AMA acknowledgement signed": "تم توقيع إقرار المغادرة ضد المشورة الطبية",
  "Abnormal Reading": "قراءة غير طبيعية",
  "Accepted": "مقبول",
  "Accordion Sections": "أقسام قابلة للطي",
  "Active Assignments": "التكليفات النشطة",
  "Active alerts:": "التنبيهات النشطة:",
  "Active members": "الأعضاء النشطون",
  "Active sessions by nurse": "الجلسات النشطة حسب الممرض",
  "Activity": "النشاط",
  "Activity level": "مستوى النشاط",
  "Activity, Diet & Equipment": "النشاط والنظام الغذائي والمعدات",
  "Add Addendum": "إضافة ملحق",
  "Add Allergy": "إضافة حساسية",
  "Add Follow-Up": "إضافة متابعة",
  "Add Intervention": "إضافة تدخل",
  "Add Section": "إضافة قسم",
  "Add a comment…": "أضف تعليقًا…",
  "Add a member…": "أضف عضوًا…",
  "Add another root question": "إضافة سؤال رئيسي آخر",
  "Add custom criterion…": "إضافة معيار مخصص…",
  "Add field": "إضافة حقل",
  "Add goal": "إضافة هدف",
  "Add me to this call": "إضافتي إلى هذه المكالمة",
  "Add member": "إضافة عضو",
  "Add option": "إضافة خيار",
  "Add problem": "إضافة مشكلة",
  "Add root question": "إضافة سؤال جذري",
  "Add rule": "إضافة قاعدة",
  "Added you to the call — refreshing room": "تمت إضافتك إلى المكالمة — جارٍ تحديث الغرفة",
  "Addendum added": "تمت إضافة الملحق",
  "Addendum content…": "محتوى الملحق…",
  "Addendum text required": "نص الملحق مطلوب",
  "Additional Notes": "ملاحظات إضافية",
  "Administration recorded": "تم تسجيل الإعطاء",
  "Admit Patient": "قبول المريض",
  "Admitted": "مقبول",
  "Age": "العمر",
  "Alert escalated to physician": "تم تصعيد التنبيه إلى الطبيب",
  "Alerts": "التنبيهات",
  "Alerts & Notifications": "التنبيهات والإشعارات",
  "All Categories": "جميع الفئات",
  "All NEWS2": "جميع NEWS2",
  "All Statuses": "جميع الحالات",
  "All actions": "جميع الإجراءات",
  "All ages": "جميع الأعمار",
  "All categories": "جميع الفئات",
  "All entities": "جميع الجهات",
  "All event types": "جميع أنواع الأحداث",
  "All facilities": "جميع المنشآت",
  "All priorities": "جميع الأولويات",
  "All priority": "جميع الأولويات",
  "All risk": "جميع المخاطر",
  "All severity": "جميع مستويات الخطورة",
  "All sources": "جميع المصادر",
  "All status": "جميع الحالات",
  "All statuses": "جميع الحالات",
  "Allergen": "مسبب الحساسية",
  "Allergen is required": "مسبب الحساسية مطلوب",
  "Allergies & Intolerances": "الحساسية وعدم التحمل",
  "Allergy marked resolved": "تم تحديد الحساسية كمحلولة",
  "Allergy recorded": "تم تسجيل الحساسية",
  "Allergy updated": "تم تحديث الحساسية",
  "Answer options": "خيارات الإجابة",
  "Approval Rate": "معدل الموافقة",
  "Approve Readmission": "الموافقة على إعادة القبول",
  "Arrived": "وصل",
  "As role:": "بصفة:",
  "Assessment completed": "تم إكمال التقييم",
  "Assessment saved": "تم حفظ التقييم",
  "Assign Patient": "تعيين مريض",
  "Assign clinician (optional)": "تعيين طبيب سريري (اختياري)",
  "Assigned to me": "مسند إليّ",
  "Assignee, due date and reason are required": "المُسند إليه وتاريخ الاستحقاق والسبب مطلوبة",
  "Assignee, due date, and reason are required": "المُسند إليه وتاريخ الاستحقاق والسبب مطلوبة",
  "At Risk": "في خطر",
  "At least one H@H technician must be assigned.": "يجب تعيين فني H@H واحد على الأقل.",
  "At least one nurse must be assigned.": "يجب تعيين ممرض/ة واحد على الأقل.",
  "Attachment removed": "تم إزالة المرفق",
  "Audit History": "سجل المراجعة",
  "Audit detail": "تفاصيل المراجعة",
  "Audit history": "سجل المراجعة",
  "Audit notice.": "إشعار المراجعة.",
  "Auto-Filled Field": "حقل مملوء تلقائياً",
  "Auto-assign on-call": "التعيين التلقائي للمناوبة",
  "Avg Consult Duration": "متوسط مدة الاستشارة",
  "Avg Travel Time": "متوسط وقت التنقل",
  "Avg Visit Duration": "متوسط مدة الزيارة",
  "Awaiting": "في انتظار",
  "BP Diastolic": "ضغط الدم الانبساطي",
  "BP Systolic": "ضغط الدم الانقباضي",
  "Basic identity and contact details.": "بيانات الهوية الأساسية ومعلومات التواصل.",
  "Bind to Lookup (optional)": "ربط بقائمة بحث (اختياري)",
  "Blood Pressure": "ضغط الدم",
  "Body": "النص",
  "Body is required": "النص مطلوب",
  "Build and manage reusable home-care teams — assign a team lead, add clinicians, and toggle availability.": "إنشاء وإدارة فرق الرعاية المنزلية القابلة لإعادة الاستخدام — تعيين قائد الفريق، وإضافة الكوادر الطبية، وتبديل حالة التوفر.",
  "Build the protocol top-down. Each question branches by Yes / No / N/A.": "أنشئ البروتوكول من الأعلى إلى الأسفل. كل سؤال يتفرع بحسب نعم / لا / لا ينطبق.",
  "By Diagnosis (Top 5)": "حسب التشخيص (أعلى 5)",
  "By RPM Status": "حسب حالة RPM",
  "Calculated Field": "حقل محسوب",
  "Call outcomes distribution": "توزيع نتائج المكالمات",
  "Capture Decision": "تسجيل القرار",
  "Capture decision": "تسجيل القرار",
  "Captured decision": "تم تسجيل القرار",
  "Care Coordinator": "منسق الرعاية",
  "Care Coordinator Request": "طلب منسق الرعاية",
  "Care Goals": "أهداف الرعاية",
  "Care Plan History": "سجل خطة الرعاية",
  "Care Record": "سجل الرعاية",
  "Care Record PDF downloaded": "تم تنزيل سجل الرعاية بصيغة PDF",
  "Care Team": "فريق الرعاية",
  "Care Teams": "فرق الرعاية",
  "Care Timeline": "الجدول الزمني للرعاية",
  "Care notes and supplementary information.": "ملاحظات الرعاية والمعلومات التكميلية.",
  "Care team created": "تم إنشاء فريق الرعاية",
  "Care team deleted": "تم حذف فريق الرعاية",
  "Care team updated": "تم تحديث فريق الرعاية",
  "Care-team data sourced from RPM enrollments. Total:": "بيانات فريق الرعاية مستمدة من تسجيلات RPM. الإجمالي:",
  "Category created": "تم إنشاء الفئة",
  "Category deleted": "تم حذف الفئة",
  "Category updated": "تم تحديث الفئة",
  "Change History": "سجل التغييرات",
  "Change Note": "ملاحظة التغيير",
  "Change note (optional, recorded in history)": "ملاحظة التغيير (اختياري، يُسجَّل في السجل)",
  "Checkbox": "مربع اختيار",
  "Checklist saved": "تم حفظ قائمة المراجعة",
  "Chief complaint": "الشكوى الرئيسية",
  "Choose user": "اختر مستخدمًا",
  "Choose…": "اختر…",
  "Clear filters": "مسح الفلاتر",
  "Clinical Bottlenecks": "الاختناقات السريرية",
  "Clinical Director": "المدير السريري",
  "Clinical Documentation Activity": "نشاط التوثيق السريري",
  "Clinical Encounters": "المقابلات السريرية",
  "Clinical Justification (required)": "المبرر السريري (مطلوب)",
  "Clinical Notes": "الملاحظات السريرية",
  "Clinical Snapshot": "اللقطة السريرية",
  "Clinical Timeline": "الجدول الزمني السريري",
  "Clinical context or instructions…": "السياق السريري أو التعليمات…",
  "Clinical document": "وثيقة سريرية",
  "Clinical impression…": "الانطباع السريري…",
  "Clinical information": "المعلومات السريرية",
  "Clinical reason for readmitting within 48 hours…": "السبب السريري لإعادة القبول خلال 48 ساعة…",
  "Close Session": "إنهاء الجلسة",
  "Command Center — Briefs": "مركز القيادة — الملخصات",
  "Comments are required.": "التعليقات مطلوبة.",
  "Comorbidities": "الأمراض المصاحبة",
  "Complete Visit": "إتمام الزيارة",
  "Complete assessment": "إتمام التقييم",
  "Complete the checklist while on-site. Save progress at any time.": "أكمل قائمة المراجعة أثناء التواجد في الموقع. يمكنك حفظ التقدم في أي وقت.",
  "Complete visit": "إتمام الزيارة",
  "Condition at discharge": "الحالة عند الخروج",
  "Condition at exit": "الحالة عند المغادرة",
  "Condition at transfer": "الحالة عند النقل",
  "Conditional logic": "المنطق الشرطي",
  "Configure lookup category scope and metadata.": "تكوين نطاق فئة البحث والبيانات الوصفية.",
  "Configure question text or convert to a terminal recommendation.": "تكوين نص السؤال أو التحويل إلى توصية نهائية.",
  "Confirm approval": "تأكيد الموافقة",
  "Confirm rejection": "تأكيد الرفض",
  "Confirm transfer": "تأكيد النقل",
  "Consultation created": "تم إنشاء الاستشارة",
  "Consultation started": "بدأت الاستشارة",
  "Consults & Visits": "الاستشارات والزيارات",
  "Contact": "التواصل",
  "Context for this reading…": "سياق هذه القراءة…",
  "Coordination": "التنسيق",
  "Coroner / medico-legal referral needed": "يلزم إحالة إلى الطب الشرعي / القانوني",
  "Could not generate the PDF. Please try again.": "تعذّر إنشاء ملف PDF. يرجى المحاولة مجدداً.",
  "Coverage": "نطاق التغطية",
  "Coverage area, specialty focus, on-call hours…": "منطقة التغطية، التخصص، ساعات المناوبة…",
  "Create Follow-Up": "إنشاء متابعة",
  "Create Progress Note": "إنشاء ملاحظة تقدم",
  "Create Teleconsult": "إنشاء استشارة عن بُعد",
  "Create Visit": "إنشاء زيارة",
  "Create a form definition. You'll design its fields next.": "أنشئ تعريف النموذج، ثم ستتمكن من تصميم حقوله.",
  "Create and manage structured care plans guiding patients to discharge.": "إنشاء وإدارة خطط رعاية منظّمة لتوجيه المرضى حتى الخروج.",
  "Create escalation": "إنشاء تصعيد",
  "Create follow-up": "إنشاء متابعة",
  "Create new patient request": "إنشاء طلب مريض جديد",
  "Critical (high)": "حرج (مرتفع)",
  "Critical (low)": "حرج (منخفض)",
  "Critical Risk Patients": "المرضى ذوو الخطورة الحرجة",
  "Current NEWS2": "NEWS2 الحالي",
  "Current question": "السؤال الحالي",
  "Custom": "مخصص",
  "Custom validation message (optional)": "رسالة التحقق المخصصة (اختياري)",
  "DOB:": "تاريخ الميلاد:",
  "Date": "التاريخ",
  "Date & time of death": "تاريخ ووقت الوفاة",
  "Date Range": "النطاق الزمني",
  "Date cannot be future": "لا يمكن أن يكون التاريخ في المستقبل",
  "Date cannot be past": "لا يمكن أن يكون التاريخ في الماضي",
  "Day off": "يوم إجازة",
  "Death certificate": "شهادة الوفاة",
  "Death verified by attending clinician": "تم التحقق من الوفاة من قِبل الطبيب المعالج",
  "Decision captured": "تم تسجيل القرار",
  "Decision notes": "ملاحظات القرار",
  "Decision notes are required.": "ملاحظات القرار مطلوبة.",
  "Decision tree": "شجرة القرار",
  "Declined": "مرفوض",
  "Default": "افتراضي",
  "Define a decision tree of questions and recommendations. Drag to reorder siblings.": "حدد شجرة قرار من الأسئلة والتوصيات. اسحب لإعادة ترتيب العناصر المتجاورة.",
  "Delete category": "حذف الفئة",
  "Deleted": "محذوف",
  "Describe the chief complaint in patient": "صف الشكوى الرئيسية للمريض",
  "Description (optional)": "الوصف (اختياري)",
  "Detailed activity log": "سجل النشاط التفصيلي",
  "Diagnoses, history and clinical context.": "التشخيصات والتاريخ المرضي والسياق السريري.",
  "Diagnosis…": "التشخيص…",
  "Diet": "النظام الغذائي",
  "Dietary": "غذائي",
  "Discharge Criteria": "معايير الخروج",
  "Discharge destination": "وجهة الخروج",
  "Discharged": "مُخرَّج",
  "Discontinue Order": "إيقاف الأمر الطبي",
  "Discontinued": "موقوف",
  "Disease Burden (Chronic Conditions)": "عبء المرض (الحالات المزمنة)",
  "Disposition Report": "تقرير التصرف",
  "Download Care Record PDF": "تنزيل سجل الرعاية بصيغة PDF",
  "Download operational reports as PDF, Excel, Word, PowerPoint or CSV — all use the H@H branded template.": "تنزيل التقارير التشغيلية بصيغة PDF أو Excel أو Word أو PowerPoint أو CSV — جميعها تستخدم قالب H@H الرسمي.",
  "Draft Requests": "الطلبات المسودة",
  "Draft saved": "تم حفظ المسودة",
  "Dropdown": "قائمة منسدلة",
  "Due date": "تاريخ الاستحقاق",
  "Edit node": "تعديل العقدة",
  "Editable by": "قابل للتعديل من قِبل",
  "Editable roles": "الأدوار المسموح لها بالتعديل",
  "Edited by": "تم التعديل بواسطة",
  "Eligible for fast-track readmission": "مؤهل لإعادة الدخول السريع",
  "Email format": "تنسيق البريد الإلكتروني",
  "En route": "في الطريق",
  "Encounter Summaries": "ملخصات الزيارات",
  "Encounters": "الزيارات",
  "End & Create Encounter": "إنهاء وإنشاء زيارة",
  "End & Save Encounter": "إنهاء وحفظ الزيارة",
  "Enroll in Remote Patient Monitoring (RPM)": "التسجيل في مراقبة المريض عن بُعد (RPM)",
  "Enter at least one value": "أدخل قيمة واحدة على الأقل",
  "Enter at least one vital": "أدخل علامة حيوية واحدة على الأقل",
  "Episodes": "الحلقات العلاجية",
  "Equipment needed": "المعدات المطلوبة",
  "Error": "خطأ",
  "Escalate": "تصعيد",
  "Escalate Alert": "تصعيد التنبيه",
  "Escalate to Physician": "تصعيد إلى الطبيب",
  "Escalated to physician": "تم التصعيد إلى الطبيب",
  "Escalation Plan": "خطة التصعيد",
  "Escalation contact": "جهة اتصال التصعيد",
  "Escalation created": "تم إنشاء التصعيد",
  "Escalation triggers": "محفزات التصعيد",
  "Event Type": "نوع الحدث",
  "Every version is preserved. Rollback creates a new published version.": "يتم حفظ كل إصدار. يؤدي الاسترجاع إلى إنشاء إصدار منشور جديد.",
  "Exp. discharge": "الخروج المتوقع",
  "Expected LOS": "مدة الإقامة المتوقعة",
  "Expected discharge date": "تاريخ الخروج المتوقع",
  "Expected length of stay (days)": "مدة الإقامة المتوقعة (أيام)",
  "Expectedness": "مدى التوقع",
  "Facility Manager": "مدير المنشأة",
  "Facility and admission information.": "معلومات المنشأة والقبول.",
  "Facility archived": "تم أرشفة المنشأة",
  "Facility created": "تم إنشاء المنشأة",
  "Facility identity and contact.": "هوية المنشأة وبيانات التواصل.",
  "Facility updated": "تم تحديث المنشأة",
  "Failed": "فشل",
  "Family notified": "تم إخطار العائلة",
  "Field": "الحقل",
  "Field Settings": "إعدادات الحقل",
  "Field type": "نوع الحقل",
  "File Upload": "رفع ملف",
  "Fill form": "تعبئة النموذج",
  "First and last name are required.": "الاسم الأول والأخير مطلوبان.",
  "Fix validation errors": "تصحيح أخطاء التحقق",
  "Fleet (visit detail)": "الأسطول (تفاصيل الزيارة)",
  "Fleet / Home Visits": "الأسطول / الزيارات المنزلية",
  "Fleet Management": "إدارة الأسطول",
  "Fleet Overview": "نظرة عامة على الأسطول",
  "Follow-Up Review": "مراجعة المتابعة",
  "Follow-up advice given": "تم تقديم نصيحة المتابعة",
  "Follow-up created": "تم إنشاء المتابعة",
  "Follow-up date": "تاريخ المتابعة",
  "Follow-up plan": "خطة المتابعة",
  "Follow-up scheduled": "تمت جدولة المتابعة",
  "Form Placement": "موضع النموذج",
  "Form cloned": "تم نسخ النموذج",
  "Form created": "تم إنشاء النموذج",
  "Form deleted": "تم حذف النموذج",
  "Form name": "اسم النموذج",
  "Form published": "تم نشر النموذج",
  "Form retired": "تم إيقاف النموذج",
  "Form submitted": "تم إرسال النموذج",
  "Full history": "السجل الكامل",
  "Full name *": "الاسم الكامل *",
  "Full name is required": "الاسم الكامل مطلوب",
  "Functional status": "الحالة الوظيفية",
  "Given": "مُعطى",
  "Given by": "مُعطى بواسطة",
  "Global ranges that drive threshold-based alerts and the vital tile colors on the Command Center.": "النطاقات العامة التي تُحدد التنبيهات القائمة على العتبات وألوان بلاطات العلامات الحيوية في مركز القيادة.",
  "Goal": "الهدف",
  "Grant feature privileges to roles or individual users. Admins always hold every privilege.": "منح صلاحيات الميزات للأدوار أو المستخدمين الأفراد. يمتلك المسؤولون دائمًا جميع الصلاحيات.",
  "Grant to individual users": "منح للمستخدمين الأفراد",
  "Grant to roles": "منح للأدوار",
  "Heads up:": "تنبيه:",
  "Heart Rate": "معدل ضربات القلب",
  "Held": "معلّق",
  "Help text": "نص المساعدة",
  "Hidden from": "مخفي عن",
  "Hidden roles": "الأدوار المخفية",
  "High Risk Patient Cohort": "مجموعة المرضى عالية الخطورة",
  "High Risk Patients Queue": "قائمة انتظار المرضى عالية الخطورة",
  "High risk patients increased by": "ارتفع عدد المرضى عالية الخطورة بمقدار",
  "Home Visit": "زيارة منزلية",
  "Home Visit Checklist": "قائمة التحقق للزيارة المنزلية",
  "Home care team assigned": "تم تعيين فريق الرعاية المنزلية",
  "Home visit completed": "اكتملت الزيارة المنزلية",
  "Home visit utilization is trending up by": "معدل استخدام الزيارات المنزلية في ارتفاع بنسبة",
  "Home visits": "الزيارات المنزلية",
  "Host module": "الوحدة المضيفة",
  "Hotline": "الخط الساخن",
  "Hotline / Tasks": "الخط الساخن / المهام",
  "Hotline patient registered": "تم تسجيل مريض الخط الساخن",
  "Hotline sessions": "جلسات الخط الساخن",
  "I acknowledge the severe allergy and proceed with this order.": "أقرّ بالحساسية الشديدة وأتابع هذا الطلب.",
  "I confirm this disposition is final and cannot be changed afterwards.": "أؤكد أن هذا القرار نهائي ولا يمكن تغييره لاحقاً.",
  "Identity and contact details of the patient.": "هوية المريض وبيانات التواصل.",
  "Imaging": "التصوير الطبي",
  "In Workflow": "قيد سير العمل",
  "In draft": "في المسودة",
  "Include patient in this call": "تضمين المريض في هذه المكالمة",
  "Incoming Video Call": "مكالمة فيديو واردة",
  "Info": "معلومات",
  "Information requested by physician": "معلومات مطلوبة من الطبيب",
  "Initial Assessment": "التقييم الأولي",
  "Initial Members": "الأعضاء الأوليون",
  "Initial assessment": "التقييم الأولي",
  "Initial credentials.": "بيانات الاعتماد الأولية.",
  "Internal name": "الاسم الداخلي",
  "Intervention recorded": "تم تسجيل التدخل",
  "Interventions & Monitoring": "التدخلات والمراقبة",
  "Invite Participant": "دعوة مشارك",
  "Invited": "مدعو",
  "Invitee Join Links": "روابط انضمام المدعوين",
  "Join Call": "الانضمام إلى المكالمة",
  "Joined": "انضم",
  "Justification is required": "المبرر مطلوب",
  "Key Insights": "الرؤى الرئيسية",
  "Lab": "المختبر",
  "Lab report": "تقرير المختبر",
  "Last Maintenance": "آخر صيانة",
  "Last changed by": "آخر تعديل بواسطة",
  "Last execution": "آخر تنفيذ",
  "Last hotline:": "آخر خط ساخن:",
  "Last update": "آخر تحديث",
  "Late": "متأخر",
  "Latest Clinical Activity": "أحدث نشاط سريري",
  "Latest Vitals": "أحدث العلامات الحيوية",
  "Leave unassigned": "ترك دون تعيين",
  "Leave unassigned (use AI Assign)": "ترك دون تعيين (استخدام التعيين بالذكاء الاصطناعي)",
  "Left": "غادر",
  "Life-threatening": "مهدد للحياة",
  "Live Activity Feed": "تغذية النشاط المباشر",
  "Live Preview": "معاينة مباشرة",
  "Live preview using the latest version definition.": "معاينة مباشرة باستخدام تعريف أحدث إصدار.",
  "Live triage queue, escalations, follow-ups, and outcomes — what": "قائمة الفرز المباشر، والتصعيد، والمتابعة، والنتائج — ما",
  "Location": "الموقع",
  "Locked": "مقفل",
  "Lookup values": "قيم البحث",
  "Lookup-bound fields auto-reflect Lookups Management changes.": "الحقول المرتبطة بالبحث تعكس تلقائيًا تغييرات إدارة البحث.",
  "MAR (Overdue Doses)": "MAR (الجرعات المتأخرة)",
  "Mark all read": "تعيين الكل كمقروء",
  "Max length": "الحد الأقصى للطول",
  "Max value": "القيمة القصوى",
  "Medical Approve": "موافقة طبية",
  "Medical Approved": "معتمد طبياً",
  "Medically approved": "معتمد طبياً",
  "Medication Administration (recent)": "إدارة الأدوية (الأخيرة)",
  "Medication Administration Record": "سجل إدارة الأدوية",
  "Medication Compliance (MAR)": "الالتزام الدوائي (MAR)",
  "Medications reconciled": "تمت مطابقة الأدوية",
  "Member added": "تمت إضافة العضو",
  "Member removed": "تمت إزالة العضو",
  "Members can also be added later from the team detail page.": "يمكن أيضاً إضافة الأعضاء لاحقاً من صفحة تفاصيل الفريق.",
  "Mild": "خفيف",
  "Min length": "الحد الأدنى للطول",
  "Min value": "القيمة الدنيا",
  "Missed": "فائت",
  "Mocked": "محاكى",
  "Mocked (provider disabled) — message logged": "محاكى (المزوّد معطّل) — تم تسجيل الرسالة",
  "Moderate (high)": "متوسط (مرتفع)",
  "Moderate (low)": "متوسط (منخفض)",
  "Moderate Risk Patients": "المرضى متوسطو الخطورة",
  "Modified (Month)": "معدَّل (الشهر)",
  "Monitoring Plan": "خطة المراقبة",
  "Multi Select": "تحديد متعدد",
  "NEWS2 Breakdown": "تفاصيل NEWS2",
  "Name and category are required": "الاسم والفئة مطلوبان",
  "Name, MRN…": "الاسم، MRN…",
  "Name, email, or role…": "الاسم، البريد الإلكتروني، أو الدور…",
  "New Care Team": "فريق رعاية جديد",
  "New Category": "فئة جديدة",
  "New Facility": "منشأة جديدة",
  "New Field": "حقل جديد",
  "New Form": "نموذج جديد",
  "New Onboarding Request": "طلب تأهيل جديد",
  "New Order": "أمر جديد",
  "New Protocol": "بروتوكول جديد",
  "New Role": "دور جديد",
  "New Session": "جلسة جديدة",
  "New User": "مستخدم جديد",
  "New Vehicle": "مركبة جديدة",
  "Next home visit:": "الزيارة المنزلية القادمة:",
  "Next steps, orders, follow-up…": "الخطوات التالية، الأوامر، المتابعة…",
  "No Known Allergies": "لا حساسية معروفة",
  "No SMS messages logged yet.": "لم يتم تسجيل رسائل SMS بعد.",
  "No SMS messages sent to this user.": "لم يتم إرسال رسائل SMS لهذا المستخدم.",
  "No active alerts.": "لا تنبيهات نشطة.",
  "No active interventions.": "لا تدخلات نشطة.",
  "No active patients match your filters.": "لا يوجد مرضى نشطون يطابقون معايير التصفية.",
  "No active staff found for this role.": "لم يُعثر على موظفين نشطين لهذا الدور.",
  "No alerts match the current filters.": "لا تنبيهات تطابق معايير التصفية الحالية.",
  "No alerts.": "لا تنبيهات.",
  "No attachments yet.": "لا مرفقات بعد.",
  "No audit entries yet.": "لا سجلات تدقيق بعد.",
  "No audit entries.": "لا سجلات تدقيق.",
  "No care plan exists for this patient yet.": "لا توجد خطة رعاية لهذا المريض بعد.",
  "No care plans here.": "لا توجد خطط رعاية هنا.",
  "No care teams yet": "لا فرق رعاية بعد",
  "No changes yet": "لا تغييرات بعد",
  "No clinicians available.": "لا يوجد أطباء سريريون متاحون.",
  "No comments yet.": "لا تعليقات بعد.",
  "No completed sessions.": "لا جلسات مكتملة.",
  "No data captured.": "لم يتم التقاط أي بيانات.",
  "No data in selected range.": "لا بيانات في النطاق المحدد.",
  "No detailed activity events for this episode.": "لا أحداث نشاط تفصيلية لهذه الحلقة العلاجية.",
  "No devices registered.": "لا توجد أجهزة مسجلة.",
  "No diagnoses recorded.": "لا توجد تشخيصات مسجلة.",
  "No encounters recorded yet.": "لم يتم تسجيل أي زيارات حتى الآن.",
  "No encounters recorded.": "لا توجد زيارات مسجلة.",
  "No escalations.": "لا توجد تصعيدات.",
  "No events yet.": "لا توجد أحداث حتى الآن.",
  "No events.": "لا توجد أحداث.",
  "No fields yet.": "لا توجد حقول حتى الآن.",
  "No follow-ups.": "لا توجد متابعات.",
  "No forms are enabled for this module yet.": "لم يتم تفعيل أي نماذج لهذه الوحدة حتى الآن.",
  "No forms found.": "لم يتم العثور على نماذج.",
  "No goals yet. Add at least one before publishing.": "لا توجد أهداف حتى الآن. أضف هدفاً واحداً على الأقل قبل النشر.",
  "No goals.": "لا توجد أهداف.",
  "No high-risk patients.": "لا يوجد مرضى عالية الخطورة.",
  "No home visits scheduled.": "لا توجد زيارات منزلية مجدولة.",
  "No hotline sessions for this patient.": "لا توجد جلسات خط ساخن لهذا المريض.",
  "No hotline sessions.": "لا توجد جلسات خط ساخن.",
  "No in-app notifications for this user.": "لا توجد إشعارات داخل التطبيق لهذا المستخدم.",
  "No individual users assigned.": "لم يتم تعيين أي مستخدمين فرديين.",
  "No interventions match.": "لا توجد تدخلات مطابقة.",
  "No interventions recorded yet.": "لم يتم تسجيل أي تدخلات حتى الآن.",
  "No interventions yet.": "لا توجد تدخلات حتى الآن.",
  "No matching patients.": "لا يوجد مرضى مطابقون.",
  "No members yet.": "لا يوجد أعضاء حتى الآن.",
  "No messages yet.": "لا توجد رسائل حتى الآن.",
  "No milestones recorded yet.": "لم يتم تسجيل أي معالم حتى الآن.",
  "No new alerts": "لا توجد تنبيهات جديدة",
  "No nodes yet. Add a root question to begin.": "لا توجد عقد حتى الآن. أضف سؤالاً جذرياً للبدء.",
  "No open alert to escalate": "لا يوجد تنبيه مفتوح للتصعيد",
  "No orders placed.": "لا توجد طلبات مسجلة.",
  "No participants joined yet.": "لم ينضم أي مشاركين حتى الآن.",
  "No patients assigned to this team yet.": "لم يتم تعيين أي مرضى لهذا الفريق حتى الآن.",
  "No patients in this group.": "لا يوجد مرضى في هذه المجموعة.",
  "No patients match your filters.": "لا يوجد مرضى يطابقون معايير التصفية.",
  "No problems added.": "لم تتم إضافة أي مشكلات.",
  "No progress notes yet.": "لا توجد ملاحظات تقدم حتى الآن.",
  "No protocols yet. Click": "لا توجد بروتوكولات حتى الآن. انقر",
  "No providers found": "لم يتم العثور على مزودين",
  "No published versions yet.": "لا توجد إصدارات منشورة حتى الآن.",
  "No recommendations available.": "لا توجد توصيات متاحة.",
  "No reviews yet.": "لا توجد مراجعات حتى الآن.",
  "No scheduled doses. Sign a medication order to populate the MAR.": "لا توجد جرعات مجدولة. وقّع أمر دواء لتعبئة MAR.",
  "No signature": "لا يوجد توقيع",
  "No submissions yet.": "لا توجد تقديمات حتى الآن.",
  "No tasks match your filters.": "لا توجد مهام تطابق عوامل التصفية.",
  "No teleconsultations for this user.": "لا توجد استشارات عن بُعد لهذا المستخدم.",
  "No teleconsultations yet.": "لا توجد استشارات عن بُعد حتى الآن.",
  "No threshold changes yet for this patient.": "لا توجد تغييرات في الحدود الحرجة لهذا المريض حتى الآن.",
  "No timeline events yet.": "لا توجد أحداث في الجدول الزمني حتى الآن.",
  "No treatment episodes found for this patient.": "لم يتم العثور على حلقات علاجية لهذا المريض.",
  "No upcoming visits.": "لا توجد زيارات قادمة.",
  "No values.": "لا توجد قيم.",
  "No vehicles registered.": "لا توجد مركبات مسجلة.",
  "No video room attached to this consultation.": "لا توجد غرفة فيديو مرتبطة بهذه الاستشارة.",
  "No visible fields.": "لا توجد حقول مرئية.",
  "No visits match the current filters.": "لا توجد زيارات تطابق عوامل التصفية الحالية.",
  "No-code engine to create, version, and publish forms across the platform.": "محرك بلا كود لإنشاء النماذج وإدارة إصداراتها ونشرها عبر المنصة.",
  "Node": "عقدة",
  "Node text is required": "نص العقدة مطلوب",
  "None scheduled.": "لا يوجد مجدول.",
  "None.": "لا شيء.",
  "Not assigned": "غير مُعيَّن",
  "Not enrolled in RPM.": "غير مسجل في RPM.",
  "Not verified": "غير مُحقَّق",
  "Not yet linked to a clinical profile": "لم يتم الربط بملف سريري بعد",
  "Note content…": "محتوى الملاحظة…",
  "Note created": "تم إنشاء الملاحظة",
  "Note signed and locked": "تم توقيع الملاحظة وقفلها",
  "Note updated": "تم تحديث الملاحظة",
  "Notes (optional)": "ملاحظات (اختياري)",
  "Nothing assigned to you yet.": "لا يوجد شيء مُسنَد إليك بعد.",
  "Nothing to compare.": "لا يوجد شيء للمقارنة.",
  "Number": "الرقم",
  "Numeric only": "أرقام فقط",
  "Nurse": "ممرضة",
  "Nurse Hotline Sessions": "جلسات خط ممرضة الاستفسار",
  "Nurse visits / day": "زيارات الممرضة / يوم",
  "Nursing": "التمريض",
  "On Track": "على المسار",
  "On Visit": "في زيارة",
  "Onboarding (request detail)": "الإدخال (تفاصيل الطلب)",
  "Onboarding Performance": "أداء الإدخال",
  "Onboarding Pipeline": "مسار الإدخال",
  "Onboarding Workflow": "سير عمل الإدخال",
  "Onboarding initiated": "تم بدء الإدخال",
  "Onset": "وقت البداية",
  "Open RPM Detail": "فتح تفاصيل RPM",
  "Open Room": "غرفة مفتوحة",
  "Open Tasks": "المهام المفتوحة",
  "Open Visit Scheduling Board": "فتح لوحة جدولة الزيارات",
  "Open only": "مفتوح فقط",
  "Open patient": "فتح ملف المريض",
  "Open referral": "فتح الإحالة",
  "Operational Alerts": "التنبيهات التشغيلية",
  "Operationally Approve": "اعتماد تشغيلي",
  "Operationally Approved": "معتمد تشغيلياً",
  "Operationally approved": "معتمد تشغيلياً",
  "Optional clinical notes for nursing": "ملاحظات سريرية اختيارية للتمريض",
  "Optional short clinical note…": "ملاحظة سريرية مختصرة اختيارية…",
  "Optional short note…": "ملاحظة مختصرة اختيارية…",
  "Optional — pick one or more": "اختياري — اختر واحداً أو أكثر",
  "Order": "أمر طبي",
  "Order (Pending Signature)": "أمر طبي (في انتظار التوقيع)",
  "Order completed": "تم إتمام الطلب",
  "Order discontinued": "تم إيقاف الطلب",
  "Order draft created. Sign it to activate.": "تم إنشاء مسودة الطلب. وقّعها لتفعيلها.",
  "Order signed and active": "الطلب موقّع ونشط",
  "Orders & MAR": "الطلبات وسجل MAR",
  "Orders + MAR": "الطلبات + MAR",
  "Other": "أخرى",
  "Outbound transactional messaging — powered by Unifonic.": "الرسائل التشغيلية الصادرة — مدعومة بـ Unifonic.",
  "Overall Risk": "المخاطر الإجمالية",
  "Overdue MAR": "سجل MAR المتأخر",
  "Override protocol recommendation": "تجاوز توصية البروتوكول",
  "Override reason (only if discharge criteria not all met)": "سبب التجاوز (فقط إذا لم تُستوفَ جميع معايير الخروج)",
  "Override reason and clinical justification are required.": "سبب التجاوز والمبرر السريري مطلوبان.",
  "PRN (administer as needed)": "PRN (يُعطى عند الحاجة)",
  "PRN reason e.g. for pain ≥4/10": "سبب PRN مثلاً: للألم ≥4/10",
  "Participant invited — SMS dispatched": "تمت دعوة المشارك — تم إرسال SMS",
  "Password must be at least 8 characters.": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
  "Passwords do not match.": "كلمتا المرور غير متطابقتين.",
  "Patient (clinical profile)": "المريض (الملف السريري)",
  "Patient / caregiver educated": "تم تثقيف المريض / مقدم الرعاية",
  "Patient Cohorts": "مجموعات المرضى",
  "Patient Risk Distribution": "توزيع مخاطر المرضى",
  "Patient Summary": "ملخص المريض",
  "Patient acknowledged leaving the program": "أقرّ المريض بمغادرة البرنامج",
  "Patient archived": "تم أرشفة المريض",
  "Patient assigned": "تم تعيين المريض",
  "Patient created": "تم إنشاء سجل المريض",
  "Patient identity and demographics.": "هوية المريض والبيانات الديموغرافية.",
  "Patient lookup": "البحث عن مريض",
  "Patient timeline": "الجدول الزمني للمريض",
  "Patient transferred": "تم نقل المريض",
  "Patient unassigned": "تم إلغاء تعيين المريض",
  "Patient updated": "تم تحديث بيانات المريض",
  "Patient visits": "زيارات المرضى",
  "Patient, MRN, room ID, session ID, user…": "المريض، MRN، رقم الغرفة، رقم الجلسة، المستخدم…",
  "Patients by Age Group": "المرضى حسب الفئة العمرية",
  "Patients by Care Team": "المرضى حسب فريق الرعاية",
  "Patients by Diagnosis (Top 5)": "المرضى حسب التشخيص (أعلى 5)",
  "Patients by Facility": "المرضى حسب المنشأة",
  "Patients by Gender": "المرضى حسب الجنس",
  "Patients by Risk Level": "المرضى حسب مستوى الخطر",
  "Pending / Draft": "معلّق / مسودة",
  "Pending Assessments": "التقييمات المعلّقة",
  "Pending Reviews": "المراجعات المعلّقة",
  "Pending Signature": "في انتظار التوقيع",
  "Per-Patient Vital Thresholds": "حدود العلامات الحيوية لكل مريض",
  "Performance Metrics": "مقاييس الأداء",
  "Permission matrix": "مصفوفة الصلاحيات",
  "Phone Number": "رقم الهاتف",
  "Phone format": "صيغة رقم الهاتف",
  "Phone, body…": "الهاتف، نص الرسالة…",
  "Physician": "الطبيب",
  "Physician Request": "طلب الطبيب",
  "Physician requested information": "معلومات مطلوبة من الطبيب",
  "Physician visits / week": "زيارات الطبيب / أسبوع",
  "Pick a decision": "اختر قراراً",
  "Pick a patient first.": "يرجى اختيار مريض أولاً.",
  "Pick a patient or uncheck": "اختر مريضاً أو ألغِ التحديد",
  "Pick a protocol category, choose a published clinical protocol, and run the guided decision tree.": "اختر فئة البروتوكول، ثم حدد بروتوكولاً سريرياً منشوراً، وشغّل شجرة القرار الإرشادية.",
  "Pick a type": "اختر نوعاً",
  "Pick an available 30-min slot": "اختر موعداً متاحاً لمدة 30 دقيقة",
  "Pick an available slot for the provider": "اختر موعداً متاحاً لمقدم الخدمة",
  "Pick an intervention type": "اختر نوع التدخل",
  "Pick at least one provider": "اختر مقدم خدمة واحداً على الأقل",
  "Pick user": "اختر مستخدماً",
  "Pick user (optional)": "اختر مستخدماً (اختياري)",
  "Place of death": "مكان الوفاة",
  "Placeholders allowed:": "العناصر النائبة المسموح بها:",
  "Placement updated": "تم تحديث التنسيب",
  "Planned Interventions": "التدخلات المخططة",
  "Plate number required": "رقم اللوحة مطلوب",
  "Please fix the highlighted fields.": "يرجى تصحيح الحقول المميزة.",
  "Please fix validation errors.": "يرجى تصحيح أخطاء التحقق.",
  "Preview as role:": "معاينة بصفة دور:",
  "Primary diagnosis:": "التشخيص الأولي:",
  "Problem": "مشكلة",
  "Problem list": "قائمة المشكلات",
  "Problems & Diagnoses": "المشكلات والتشخيصات",
  "Progress note saved as draft": "تم حفظ ملاحظة التقدم كمسودة",
  "Protocol created": "تم إنشاء البروتوكول",
  "Protocol deleted": "تم حذف البروتوكول",
  "Protocol duplicated": "تم تكرار البروتوكول",
  "Protocol execution saved": "تم حفظ تنفيذ البروتوكول",
  "Protocol saved": "تم حفظ البروتوكول",
  "Provider Response": "استجابة المزوّد",
  "Providers": "مزودو الخدمة",
  "Publish draft": "نشر المسودة",
  "Question & recommendation flow": "تسلسل الأسئلة والتوصيات",
  "Queued": "في قائمة الانتظار",
  "Quick stats": "إحصائيات سريعة",
  "RPM enrolled": "مسجّل في RPM",
  "RPM monitoring enabled": "تم تفعيل مراقبة RPM",
  "Radio Button": "زر اختيار",
  "Radiology report": "تقرير الأشعة",
  "Reaction": "التفاعل",
  "Read Only Field": "حقل للقراءة فقط",
  "Read-only for": "للقراءة فقط لـ",
  "Read-only roles": "أدوار القراءة فقط",
  "Readmission pending physician approval": "إعادة القبول بانتظار موافقة الطبيب",
  "Readmission rate improved by": "تحسّن معدل إعادة القبول بنسبة",
  "Readmission requested — sent to physician for approval": "تم طلب إعادة القبول — أُرسل إلى الطبيب للموافقة",
  "Real-time positions for clinicians, patients with active visits, and fleet vehicles.": "المواقع الفورية للأطقم الطبية والمرضى ذوي الزيارات النشطة ومركبات الأسطول.",
  "Reason for leaving": "سبب المغادرة",
  "Reason for transfer": "سبب النقل",
  "Reason required": "السبب مطلوب",
  "Reason required when not administered": "السبب مطلوب عند عدم الإعطاء",
  "Receiving facility": "المنشأة المستقبِلة",
  "Recent Encounters": "المقابلات الأخيرة",
  "Recent Hotline": "الخط الساخن الأخير",
  "Recent encounters": "المقابلات الأخيرة",
  "Recipient": "المستلم",
  "Recipient (international format)": "المستلم (بالتنسيق الدولي)",
  "Recipient phone required": "رقم هاتف المستلم مطلوب",
  "Recommended Action": "الإجراء الموصى به",
  "Recommended action:": "الإجراء الموصى به:",
  "Record": "تسجيل",
  "Record Administration": "تسجيل الإعطاء",
  "Record Vitals": "تسجيل العلامات الحيوية",
  "Record the clinical decision for this hotline call.": "سجّل القرار السريري لهذه المكالمة على الخط الساخن.",
  "Referral form": "نموذج الإحالة",
  "Referral form, clinical documents, lab/radiology reports.": "نموذج الإحالة والوثائق السريرية وتقارير المختبر/الأشعة.",
  "Referral information": "معلومات الإحالة",
  "Refresh now": "تحديث الآن",
  "Refused": "مرفوض",
  "Region": "المنطقة",
  "Register hotline patient": "تسجيل مريض الخط الساخن",
  "Register new": "تسجيل جديد",
  "Reject Readmission": "رفض إعادة القبول",
  "Rejection Rate": "معدل الرفض",
  "Rejection reason": "سبب الرفض",
  "Rejection reason is required.": "سبب الرفض مطلوب.",
  "Related module": "الوحدة ذات الصلة",
  "Remote Patient Monitoring": "المراقبة عن بُعد للمريض",
  "Request Information": "طلب معلومات",
  "Request information": "طلب معلومات",
  "Request readmission": "طلب إعادة القبول",
  "Request rejected": "تم رفض الطلب",
  "Request submitted for medical review": "تم تقديم الطلب للمراجعة الطبية",
  "Requested information is required.": "المعلومات المطلوبة إلزامية.",
  "Require this": "جعل هذا إلزامياً",
  "Required skill": "المهارة المطلوبة",
  "Required when dose not administered": "مطلوب عند عدم إعطاء الجرعة",
  "Reset password": "إعادة تعيين كلمة المرور",
  "Reset to default": "إعادة التعيين إلى الافتراضي",
  "Respiratory Rate": "معدل التنفس",
  "Responsible physicians": "الأطباء المسؤولون",
  "Retired": "متقاعد",
  "Ringing": "يرن",
  "Risk": "خطر",
  "Risks of leaving explained to patient": "تم شرح مخاطر المغادرة للمريض",
  "Role and facility assignments.": "تعيينات الدور والمنشأة.",
  "Role cloned": "تم استنساخ الدور",
  "Role created": "تم إنشاء الدور",
  "Role deleted": "تم حذف الدور",
  "Role in team": "الدور في الفريق",
  "Role updated": "تم تحديث الدور",
  "Route this case to the appropriate team.": "قم بتوجيه هذه الحالة إلى الفريق المناسب.",
  "Routine": "روتيني",
  "Run License Scan": "تشغيل فحص الترخيص",
  "SLA Breach": "خرق SLA",
  "SLA Performance": "أداء SLA",
  "SLA Performance Overview": "نظرة عامة على أداء SLA",
  "SLA Watch": "مراقبة SLA",
  "SMS Failed": "فشل إرسال SMS",
  "SMS Message Detail": "تفاصيل رسالة SMS",
  "SMS Messages": "رسائل SMS",
  "SMS Templates": "قوالب SMS",
  "Sample variables (for preview)": "متغيرات نموذجية (للمعاينة)",
  "Save Draft": "حفظ المسودة",
  "Save Note": "حفظ الملاحظة",
  "Save assessment": "حفظ التقييم",
  "Save execution": "حفظ التنفيذ",
  "Save node": "حفظ العقدة",
  "Save progress": "حفظ التقدم",
  "Save the protocol execution and capture the decision.": "حفظ تنفيذ البروتوكول وتسجيل القرار.",
  "Schedule Consultation": "جدولة استشارة",
  "Schedule Follow-Up": "جدولة متابعة",
  "Schedule Teleconsultation": "جدولة استشارة عن بُعد",
  "Schedule a follow-up task for this patient.": "جدولة مهمة متابعة لهذا المريض.",
  "Scheduled": "مجدول",
  "Scheduled at": "مجدول في",
  "Scheduled time (optional)": "وقت الجدولة (اختياري)",
  "Search H@H users (clinicians, coordinators, etc.)": "البحث عن مستخدمي H@H (الأطباء، المنسقون، إلخ)",
  "Search alerts…": "البحث في التنبيهات…",
  "Search by MRN, name, mobile, or national ID. If no result, register a hotline-only patient.": "البحث بـ MRN أو الاسم أو الجوال أو رقم الهوية الوطنية. إذا لم تظهر نتائج، سجّل مريضاً للخط الساخن فقط.",
  "Search by name / MRN / diagnosis…": "البحث بالاسم / MRN / التشخيص…",
  "Search by name or MRN…": "البحث بالاسم أو MRN…",
  "Search by name or code…": "البحث بالاسم أو الرمز…",
  "Search by name, MRN or phone…": "البحث بالاسم أو MRN أو الهاتف…",
  "Search by patient, MRN, visit type…": "البحث بالمريض أو MRN أو نوع الزيارة…",
  "Search by team name…": "البحث باسم الفريق…",
  "Search categories…": "البحث في الفئات…",
  "Search clinicians…": "البحث عن الأطباء…",
  "Search existing patient or create new": "البحث عن مريض موجود أو إنشاء جديد",
  "Search forms…": "البحث في النماذج…",
  "Search interventions…": "البحث في التدخلات…",
  "Search name, MRN, phone…": "البحث بالاسم أو MRN أو الهاتف…",
  "Search patients…": "البحث عن المرضى…",
  "Search users by name or email…": "البحث عن المستخدمين بالاسم أو البريد الإلكتروني…",
  "Search values…": "البحث عن القيم…",
  "Search…": "بحث…",
  "Section Header": "عنوان القسم",
  "Section Settings": "إعدادات القسم",
  "Section settings": "إعدادات القسم",
  "Select (optional)": "اختيار (اختياري)",
  "Select a category to manage its values.": "اختر فئة لإدارة قيمها.",
  "Select a clinician": "اختر طبيبًا سريريًا",
  "Select a field or section to configure it.": "اختر حقلًا أو قسمًا لتكوينه.",
  "Select a patient": "اختر مريضًا",
  "Select a provider above to see their available slots.": "اختر مزودًا أعلاه لعرض المواعيد المتاحة.",
  "Select a reason": "اختر سببًا",
  "Select a role to view permissions.": "اختر دورًا لعرض الصلاحيات.",
  "Select a user": "اختر مستخدمًا",
  "Select a visit type": "اختر نوع الزيارة",
  "Select an outcome…": "اختر نتيجة…",
  "Select category": "اختر الفئة",
  "Select destination facility": "اختر المنشأة المستقبِلة",
  "Select facility": "اختر المنشأة",
  "Select lead": "اختر المسؤول",
  "Select module": "اختر الوحدة",
  "Select one or more…": "اختر واحدًا أو أكثر…",
  "Select role": "اختر الدور",
  "Select type": "اختر النوع",
  "Selected slot:": "الموعد المحدد:",
  "Select…": "اختر…",
  "Send Test SMS": "إرسال SMS تجريبي",
  "Send request": "إرسال الطلب",
  "Sent": "تم الإرسال",
  "Sent successfully": "تم الإرسال بنجاح",
  "Service request": "طلب خدمة",
  "Services": "الخدمات",
  "Services offered and coverage.": "الخدمات المقدَّمة ونطاق التغطية.",
  "Session closed": "الجلسة مغلقة",
  "Session information": "معلومات الجلسة",
  "Sessions breaching or approaching SLA": "الجلسات المخالِفة أو المقتربة من SLA",
  "Severe": "حرج",
  "Ships with Clinical Documentation & Orders module": "يأتي مع وحدة التوثيق السريري والأوامر",
  "Show resolved": "عرض المحلولة",
  "Show this": "عرض هذا",
  "Sign in the box above": "وقّع في المربع أعلاه",
  "Signature": "التوقيع",
  "Signed in as": "مسجّل الدخول بوصفك",
  "Single Column": "عمود واحد",
  "Skipped (no phone)": "تم التخطي (لا يوجد هاتف)",
  "Stable Patients": "المرضى المستقرون",
  "Stable max": "الحد الأقصى للاستقرار",
  "Stable min": "الحد الأدنى للاستقرار",
  "Start Now": "ابدأ الآن",
  "Start Teleconsult": "بدء الاستشارة عن بُعد",
  "Start Visit": "بدء الزيارة",
  "Start by adding a section.": "ابدأ بإضافة قسم.",
  "Start now (instant call)": "ابدأ الآن (اتصال فوري)",
  "Static options (below)": "خيارات ثابتة (أدناه)",
  "Status distribution": "توزيع الحالة",
  "Structured care plans guiding patients to discharge.": "خطط رعاية منظّمة توجّه المرضى نحو الخروج.",
  "Structured nurse-led assessment.": "تقييم منظّم بقيادة الممرضة.",
  "Submit Reading": "إرسال القراءة",
  "Submit Vital Reading": "إرسال قراءة العلامات الحيوية",
  "Submit for approval": "إرسال للاعتماد",
  "Submitted for review": "تم الإرسال للمراجعة",
  "System": "النظام",
  "System-generated metadata.": "بيانات وصفية مُنشأة تلقائياً من النظام.",
  "Taken at": "تم الأخذ في",
  "Target date": "التاريخ المستهدف",
  "Tasks Overview": "نظرة عامة على المهام",
  "Team Lead": "قائد الفريق",
  "Team Name": "اسم الفريق",
  "Team name is required": "اسم الفريق مطلوب",
  "Teleconsultation created": "تم إنشاء الاستشارة عن بُعد",
  "Teleconsultation scheduled": "تمت جدولة الاستشارة عن بُعد",
  "Teleconsultations": "الاستشارات عن بُعد",
  "Teleconsults": "استشارات عن بُعد",
  "Teleconsults / week": "استشارات عن بُعد / أسبوع",
  "Temperature": "درجة الحرارة",
  "Template saved": "تم حفظ القالب",
  "Text": "نص",
  "Text Area": "منطقة نص",
  "This episode only": "هذه الحلقة فقط",
  "This form has no visible sections for the selected role.": "لا توجد أقسام مرئية في هذا النموذج للدور المحدد.",
  "This session has spawned a downstream onboarding draft.": "أنشأت هذه الجلسة مسودة تأهيل لاحقة.",
  "Three Column": "ثلاثة أعمدة",
  "Timezone": "المنطقة الزمنية",
  "Toggle columns": "تبديل الأعمدة",
  "Top Diagnoses": "أبرز التشخيصات",
  "Total": "الإجمالي",
  "Total Active Patients": "إجمالي المرضى النشطين",
  "Total Clinicians": "إجمالي الأطباء السريريين",
  "Total Forms": "إجمالي النماذج",
  "Total Monitored": "إجمالي المراقَبين",
  "Total Requests": "إجمالي الطلبات",
  "Total Tasks": "إجمالي المهام",
  "Total Vehicles": "إجمالي المركبات",
  "Total Visits": "إجمالي الزيارات",
  "Total teams": "إجمالي الفرق",
  "Transfer patient": "نقل المريض",
  "Transfer type": "نوع النقل",
  "Transfer-of-care documents sent": "تم إرسال وثائق نقل الرعاية",
  "Transferred": "تم النقل",
  "Transport mode": "وسيلة النقل",
  "Treatment Episodes": "حلقات العلاج",
  "Two Column": "عمودان",
  "Type a message…": "اكتب رسالة…",
  "Type and reason are required": "النوع والسبب مطلوبان",
  "Unassign": "إلغاء التعيين",
  "Unassigned": "غير معيّن",
  "Unavailable": "غير متاح",
  "Unique value": "قيمة فريدة",
  "Upcoming": "القادمة",
  "Upcoming Teleconsults:": "الاستشارات عن بُعد القادمة:",
  "Upcoming Visits": "الزيارات القادمة",
  "Urgent": "عاجل",
  "Urgent visits": "الزيارات العاجلة",
  "Use static options": "استخدام الخيارات الثابتة",
  "Use suggested decision": "استخدام القرار المقترح",
  "User agent": "وكيل المستخدم",
  "User created": "تم إنشاء المستخدم",
  "User deleted": "تم حذف المستخدم",
  "User updated": "تم تحديث المستخدم",
  "Value": "القيمة",
  "Value created": "تم إنشاء القيمة",
  "Value deleted": "تم حذف القيمة",
  "Value updated": "تم تحديث القيمة",
  "Variables (JSON)": "المتغيرات (JSON)",
  "Variables must be valid JSON": "يجب أن تكون المتغيرات JSON صالحًا",
  "Vehicle Status": "حالة المركبة",
  "Vehicle saved": "تم حفظ المركبة",
  "Version History": "سجل الإصدارات",
  "View All Alerts": "عرض جميع التنبيهات",
  "View All Visits": "عرض جميع الزيارات",
  "View Details": "عرض التفاصيل",
  "View Full Risk Report": "عرض تقرير المخاطر الكامل",
  "View Full Schedule": "عرض الجدول الزمني الكامل",
  "View Onboarding SLA": "عرض SLA الإلحاق",
  "View Patients": "عرض المرضى",
  "View Report": "عرض التقرير",
  "View Session": "عرض الجلسة",
  "View a clinician": "عرض إكلينيكي",
  "View all": "عرض الكل",
  "Visible roles": "الأدوار المرئية",
  "Visible to": "مرئي لـ",
  "Visit Checklist": "قائمة مراجعة الزيارة",
  "Visit Forms": "نماذج الزيارة",
  "Visit In Progress": "الزيارة جارية",
  "Visit Plan": "خطة الزيارة",
  "Visit Plan & Team": "خطة الزيارة والفريق",
  "Visit assigned": "تم تعيين الزيارة",
  "Visit completed": "تمت الزيارة",
  "Visit created": "تم إنشاء الزيارة",
  "Visit created and assigned": "تم إنشاء الزيارة وتعيينها",
  "Visit date is required.": "تاريخ الزيارة مطلوب.",
  "Visit evidence (photos)": "مستندات الزيارة (صور)",
  "Visit findings": "نتائج الزيارة",
  "Visit notes": "ملاحظات الزيارة",
  "Visit type": "نوع الزيارة",
  "Visits Completed": "الزيارات المكتملة",
  "Visits Overview": "نظرة عامة على الزيارات",
  "Visits Trends (Last 7 Days)": "اتجاهات الزيارات (آخر 7 أيام)",
  "Vital signs, exam findings…": "العلامات الحيوية، نتائج الفحص…",
  "Walkthrough complete": "اكتمل الإرشاد التفصيلي",
  "Warning": "تحذير",
  "Watheeq video room": "غرفة فيديو وثيق",
  "What": "ماذا",
  "What service is being requested.": "الخدمة المطلوبة.",
  "When": "متى",
  "When on, the form appears in the selected module for matching records.": "عند التفعيل، يظهر النموذج في الوحدة المحددة للسجلات المطابقة.",
  "Who is referring this patient.": "من يُحيل هذا المريض.",
  "Why is this being escalated to a physician?": "ما سبب تصعيد هذه الحالة إلى الطبيب؟",
  "With Alerts": "مع التنبيهات",
  "Wizard Steps": "خطوات المعالج",
  "Workforce Overview": "نظرة عامة على القوى العاملة",
  "Workforce Utilization": "استخدام القوى العاملة",
  "YYYY-MM-DD or": "YYYY-MM-DD أو",
  "You don't have access to care plans.": "ليس لديك صلاحية الوصول إلى خطط الرعاية.",
  "You have read-only access to this form's category.": "لديك صلاحية قراءة فقط لفئة هذا النموذج.",
  "You're all caught up.": "لقد اطلعت على كل شيء.",
  "Your role can view but not disposition patients.": "دورك يتيح لك عرض المرضى فقط دون صلاحية البت في وضعهم.",
  "Your worklist": "قائمة مهامك",
  "does not equal": "لا يساوي",
  "e.g. 500mg": "مثال: 500mg",
  "e.g. Amoxicillin 500mg": "مثال: Amoxicillin 500mg",
  "e.g. Anaphylaxis, Hives, GI upset": "مثال: صدمة تأقية، شرى، اضطراب هضمي",
  "e.g. CBC, Chest X-ray": "مثال: CBC، أشعة صدر",
  "e.g. Follow-Up Assessment": "مثال: تقييم متابعة",
  "e.g. Friendlier tone for KSA rollout": "مثال: أسلوب أكثر ودية لإطلاق المنتج في KSA",
  "e.g. Known COPD with chronic baseline SpO2 around 92%, accept lower critical threshold for this patient.": "مثال: مريض معروف بـ COPD مع مستوى SpO2 الأساسي المزمن حوالي 92%، يُقبل عتبة حرجة أدنى لهذا المريض.",
  "e.g. MD, RN": "مثال: MD، RN",
  "e.g. Penicillin, Peanuts, Latex": "مثال: بنسلين، فول سوداني، لاتكس",
  "e.g. Right deltoid": "مثال: العضلة الدالية اليمنى",
  "e.g. allergic reaction noted, regimen changed…": "مثال: لوحظت تفاعل تحسسي، تم تغيير النظام العلاجي…",
  "e.g. patient reassured, repeat reading scheduled": "مثال: تم طمأنة المريض، تمت جدولة قراءة متكررة",
  "e.g. r/o pneumonia": "مثال: r/o التهاب رئوي",
  "e.g., 2 hours": "مثال: ساعتان",
  "e.g., MD, RN, BSN": "مثال: MD، RN، BSN",
  "e.g., Riyadh North Team": "مثال: فريق شمال الرياض",
  "is empty": "فارغ",
  "is filled": "مملوء",
  "is greater than": "أكبر من",
  "is less than": "أصغر من",
  "is one of": "هو أحد",

  // ── Auto-translated UI phrases (map values / subtitles) ──────────
  "Accessible residence": "مسكن مناسب",
  "Active H@H Patients": "مرضى H@H النشطون",
  "Active Orders": "الأوامر النشطة",
  "Active RPM enrollments": "تسجيلات RPM النشطة",
  "Active templates configured by the admin team.": "القوالب النشطة التي هيأها فريق الإدارة.",
  "Active visits": "الزيارات النشطة",
  "Add a new H@H facility to the network.": "إضافة منشأة H@H جديدة إلى الشبكة.",
  "Add a new user to the platform.": "إضافة مستخدم جديد إلى المنصة.",
  "Add at least one node": "أضف عقدة واحدة على الأقل",
  "Address the information requested by the physician and resubmit.": "عالج المعلومات المطلوبة من الطبيب وأعد التقديم.",
  "Address verification": "التحقق من العنوان",
  "Admit patient": "قبول المريض",
  "Admitted in the last 24 hours": "تم القبول خلال الـ 24 ساعة الماضية",
  "Advice patient": "تقديم النصيحة للمريض",
  "Against medical advice (AMA)": "ضد النصيحة الطبية (AMA)",
  "All onboarding requests across the H@H network.": "جميع طلبات الانضمام عبر شبكة H@H.",
  "All roles": "جميع الأدوار",
  "All sessions": "جميع الجلسات",
  "Ambulance Recommended": "يُوصى بالإسعاف",
  "Approve readmission": "الموافقة على إعادة القبول",
  "Approved for home care": "معتمد للرعاية المنزلية",
  "Approving will forward this request to the H@H Care Coordinator for operational assessment.": "ستؤدي الموافقة إلى إحالة هذا الطلب إلى منسق رعاية H@H للتقييم التشغيلي.",
  "Approving will mark this request ready for home care team assignment.": "ستؤدي الموافقة إلى تحديد هذا الطلب جاهزاً لتعيين فريق الرعاية المنزلية.",
  "Archive facility": "أرشفة المنشأة",
  "Archive patient": "أرشفة المريض",
  "Ask the H@H Care Coordinator to create care teams.": "اطلب من منسق رعاية H@H إنشاء فرق الرعاية.",
  "Auto OFF": "إيقاف تلقائي",
  "Auto ON": "تشغيل تلقائي",
  "BP Dia": "BP انبساطي",
  "Below expected today": "أقل من المتوقع اليوم",
  "Blocked by allergy": "محظور بسبب حساسية",
  "Bulk acknowledged from RPM card": "تم الإقرار الجماعي من بطاقة RPM",
  "Calls received today": "المكالمات المستلمة اليوم",
  "Capture admission details for a new patient.": "تسجيل تفاصيل قبول مريض جديد.",
  "Caregiver Assessment": "تقييم مقدم الرعاية",
  "Caregiver Contacted": "تم التواصل مع مقدم الرعاية",
  "Caregiver available": "مقدم الرعاية متاح",
  "Caregiver name": "اسم مقدم الرعاية",
  "Caregiver verification": "التحقق من مقدم الرعاية",
  "Companion verification": "التحقق من المرافق",
  "Caregiver willing": "مقدم الرعاية موافق",
  "Companion": "مرافق",
  "Companion Assessment": "تقييم المرافق",
  "Companion available": "المرافق متاح",
  "Companion name": "اسم المرافق",
  "Companion willing": "المرافق موافق",
  "Choose a file": "اختر ملفاً",
  "Clinical referrals awaiting your medical decision.": "الإحالات السريرية في انتظار قرارك الطبي.",
  "Closed by nurse.": "تم الإغلاق من قِبل الممرض.",
  "Code is required": "الرمز مطلوب",
  "Collapse sidebar": "طي الشريط الجانبي",
  "Complete the initial assessment first": "أكمل التقييم الأولي أولاً",
  "Confirm disposition": "تأكيد التصرف",
  "Connectivity verification": "التحقق من الاتصال",
  "Consent Readiness": "جاهزية الموافقة",
  "Consultation scheduled — links sent": "تمت جدولة الاستشارة — تم إرسال الروابط",
  "Contact number": "رقم التواصل",
  "Continue Monitoring": "متابعة المراقبة",
  "Conversion Rate": "معدل التحويل",
  "Create & Design": "إنشاء وتصميم",
  "Create Care Team": "إنشاء فريق الرعاية",
  "Create Draft": "إنشاء مسودة",
  "Create Onboarding Request": "إنشاء طلب تأهيل",
  "Create Team": "إنشاء فريق",
  "Create care plan": "إنشاء خطة رعاية",
  "Create facility": "إنشاء منشأة",
  "Create role": "إنشاء دور",
  "Create session": "إنشاء جلسة",
  "Create user": "إنشاء مستخدم",
  "Critical Patients": "المرضى الحرجون",
  "Date cannot be in the future.": "لا يمكن أن يكون التاريخ في المستقبل.",
  "Date cannot be in the past.": "لا يمكن أن يكون التاريخ في الماضي.",
  "Declined during onboarding": "تم الرفض أثناء التأهيل",
  "Define a new role for the platform.": "حدِّد دوراً جديداً للمنصة.",
  "Delayed Visits": "الزيارات المتأخرة",
  "Delete form": "حذف النموذج",
  "Delete protocol": "حذف البروتوكول",
  "Delete role": "حذف الدور",
  "Delete user": "حذف المستخدم",
  "Delete value": "حذف القيمة",
  "Delete vehicle": "حذف المركبة",
  "Describe the chief complaint in patient's own words…": "صف الشكوى الرئيسية بكلمات المريض...",
  "Deterministic explanation": "تفسير حتمي",
  "Device Status": "حالة الجهاز",
  "Dietitian Consult": "استشارة أخصائي التغذية",
  "Direct assignment at visit creation": "تعيين مباشر عند إنشاء الزيارة",
  "Discharge patient": "تخريج المريض",
  "Discharged today": "مُخرَّج اليوم",
  "Dispatch ambulance": "إرسال سيارة الإسعاف",
  "Disposition date": "تاريخ التصرف",
  "Download PDF": "تنزيل PDF",
  "Download failed": "فشل التنزيل",
  "Dr. Reem Al-Omari": "د. ريم العمري",
  "ED Referral": "إحالة طوارئ",
  "Edit Allergy": "تعديل الحساسية",
  "Edit Care Team": "تعديل فريق الرعاية",
  "Edit Protocol": "تعديل البروتوكول",
  "Edit Vehicle": "تعديل المركبة",
  "Edit category": "تعديل الفئة",
  "Edit role": "تعديل الدور",
  "Edit user": "تعديل المستخدم",
  "Edit value": "تعديل القيمة",
  "Electricity available": "الكهرباء متوفرة",
  "Email is required": "البريد الإلكتروني مطلوب",
  "Enter a valid email address.": "أدخل عنوان بريد إلكتروني صحيحاً.",
  "Enter a valid phone number.": "أدخل رقم هاتف صحيحاً.",
  "Escalated to clinician": "تمت الإحالة إلى الطبيب السريري",
  "Evaluate Thresholds": "تقييم العتبات",
  "Expand sidebar": "توسيع الشريط الجانبي",
  "Field Team": "فريق الميدان",
  "Fill and submit this form.": "املأ هذا النموذج وأرسله.",
  "First name is required": "الاسم الأول مطلوب",
  "Fleet visit": "زيارة الأسطول",
  "Fleet visits dispatched today": "زيارات الأسطول المُرسَلة اليوم",
  "Follow-up Visit": "زيارة متابعة",
  "Follow-up after hotline session": "متابعة بعد جلسة الخط الساخن",
  "Follow-up required": "متابعة مطلوبة",
  "Fully approved and activated patients in the Hospital @ Home program.": "المرضى المعتمدون والمُفعَّلون بالكامل في برنامج H@H.",
  "Hassan Al-Awfi": "حسان العوفي",
  "Hide full Care Record": "إخفاء سجل الرعاية الكامل",
  "Home Environment": "بيئة المنزل",
  "Home environment verification": "التحقق من بيئة المنزل",
  "Home visit": "زيارة منزلية",
  "Hotline Escalation": "تصعيد الخط الساخن",
  "Hotline Follow-up": "متابعة الخط الساخن",
  "If YES": "إذا كانت الإجابة نعم",
  "In Assessment": "قيد التقييم",
  "Infection control assessment": "تقييم مكافحة العدوى",
  "Information requested": "المعلومات المطلوبة",
  "Initial assessments, operational approvals, and team assignments.": "التقييمات الأولية والموافقات التشغيلية وتكليفات الفريق.",
  "Initiate a Hospital @ Home referral. Save as draft or submit for medical review.": "إنشاء إحالة H@H. احفظ كمسودة أو أرسل للمراجعة الطبية.",
  "Initiated from Clinical Operations workspace.": "بدأ من مساحة عمل العمليات السريرية.",
  "Initiated from RPM patient detail.": "بدأ من تفاصيل مريض RPM.",
  "Initiated from patient profile.": "بدأ من ملف المريض.",
  "Instant call started — links sent": "بدأت المكالمة الفورية — تم إرسال الروابط",
  "Internet available": "الإنترنت متاح",
  "Intervention notes (required)": "ملاحظات التدخل (مطلوبة)",
  "Invalid email": "البريد الإلكتروني غير صالح",
  "Invite & Send Link": "دعوة وإرسال الرابط",
  "KPI fetch failed": "فشل جلب بيانات KPI",
  "Khulood Al-Maliki": "خلود المالكي",
  "Lab Collection": "تجميع عينات المختبر",
  "Last name is required": "اسم العائلة مطلوب",
  "Live triage queue, escalations, follow-ups, and outcomes — what's happening right now.": "قائمة الفرز المباشر والتصعيدات والمتابعات والنتائج — ما يحدث الآن.",
  "ML-predicted decline": "تراجع متوقع بالذكاء الاصطناعي",
  "MRN assigned": "تم تعيين MRN",
  "MRN is required": "MRN مطلوب",
  "Manage your patient referrals into the H@H program.": "إدارة إحالات المرضى إلى برنامج H@H.",
  "Medical Review": "المراجعة الطبية",
  "Medical approval": "الموافقة الطبية",
  "Medical approval recorded": "تم تسجيل الموافقة الطبية",
  "Medical rejection": "الرفض الطبي",
  "Medication Admin": "إدارة الأدوية",
  "Medication Review": "مراجعة الأدوية",
  "Medication Review Requested": "تم طلب مراجعة الأدوية",
  "Member activated": "تم تفعيل العضو",
  "Member deactivated": "تم تعطيل العضو",
  "Missed Home Visits": "الزيارات المنزلية الفائتة",
  "Missed MAR": "MAR الفائت",
  "Mobile coverage": "تغطية الشبكة المحمولة",
  "Must be a number.": "يجب أن تكون قيمة رقمية.",
  "NEWS2 0–2, no breach": "NEWS2 0–2، لا يوجد خرق",
  "NEWS2 3–4 or single yellow": "NEWS2 3–4 أو تنبيه أصفر منفرد",
  "NEWS2 5–6 or multi-yellow": "NEWS2 5–6 أو تنبيهات صفراء متعددة",
  "Name is required": "الاسم مطلوب",
  "Name your team, assign a lead, and optionally add initial members.": "حدد اسم الفريق، وعيّن مسؤولاً، وأضف الأعضاء الأوليين اختيارياً.",
  "Needs review": "يحتاج إلى مراجعة",
  "New Section": "قسم جديد",
  "New category": "فئة جديدة",
  "New value": "قيمة جديدة",
  "No active sessions.": "لا توجد جلسات نشطة.",
  "No care plan on file.": "لا تتوفر خطة رعاية مسجلة.",
  "No care record available.": "لا تتوفر سجلات رعاية.",
  "No clinical activity recorded yet.": "لم يتم تسجيل أي نشاط سريري حتى الآن.",
  "No clinical notes recorded.": "لم يتم تسجيل أي ملاحظات سريرية.",
  "No common availability for these providers on this day.": "لا يوجد وقت مشترك متاح لهؤلاء مقدمي الخدمة في هذا اليوم.",
  "No consultations match your filters.": "لا توجد استشارات تطابق معايير التصفية.",
  "No consultations yet — schedule one to get started.": "لا توجد استشارات بعد — قم بجدولة استشارة للبدء.",
  "No decision captured": "لم يتم تسجيل أي قرار",
  "No description": "لا يوجد وصف",
  "No description.": "لا يوجد وصف.",
  "No encounters.": "لا توجد مقابلات.",
  "No episodes found.": "لا توجد حلقات علاجية.",
  "No home visits.": "لا توجد زيارات منزلية.",
  "No matches.": "لا توجد نتائج مطابقة.",
  "No matching users (already-invited people are filtered out).": "لا يوجد مستخدمون مطابقون (تم استبعاد المدعوين مسبقاً).",
  "No medication administration records.": "لا توجد سجلات إعطاء الدواء.",
  "No open escalations.": "لا توجد تصعيدات مفتوحة.",
  "No options": "لا توجد خيارات",
  "No orders recorded.": "لا توجد أوامر مسجلة.",
  "No pending follow-ups.": "لا توجد متابعات معلقة.",
  "No records found.": "لا توجد سجلات.",
  "No suggested routes today": "لا توجد مسارات مقترحة اليوم",
  "No teleconsultations.": "لا توجد استشارات عن بُعد.",
  "No vitals recorded.": "لا توجد علامات حيوية مسجلة.",
  "None required": "غير مطلوب",
  "Normal Max": "الحد الأقصى الطبيعي",
  "Normal Min": "الحد الأدنى الطبيعي",
  "Not enrolled.": "غير مسجّل.",
  "Not yet published": "لم يُنشر بعد",
  "Nursing Consult": "استشارة تمريضية",
  "On active visit": "في زيارة نشطة",
  "On schedule": "وفق الجدول",
  "On the way": "في الطريق",
  "Onboarded today": "تم التسجيل اليوم",
  "Open & complete": "مفتوح ومكتمل",
  "Open Sessions": "الجلسات المفتوحة",
  "Open full plan": "فتح الخطة الكاملة",
  "Operational approval": "الموافقة التشغيلية",
  "Operational approval recorded": "تم تسجيل الموافقة التشغيلية",
  "Operational rejection": "الرفض التشغيلي",
  "Ops Review": "المراجعة التشغيلية",
  "Optional — where this form is used (e.g. onboarding, fleet).": "اختياري — مكان استخدام هذا النموذج (مثل: التسجيل، الأسطول).",
  "Order details…": "تفاصيل الأمر...",
  "Overdue Interventions": "تدخلات متأخرة",
  "Overdue Tasks": "مهام متأخرة",
  "PDF export failed": "فشل تصدير PDF",
  "Patient Contacted": "تم التواصل مع المريض",
  "Patient Understanding": "فهم المريض",
  "Patient understands Hospital @ Home": "المريض يفهم برنامج H@H",
  "Patient understands escalation process": "المريض يفهم إجراءات التصعيد",
  "Patient verification": "التحقق من هوية المريض",
  "Patient willing to participate": "المريض موافق على المشاركة",
  "Patient willing to sign consent": "المريض موافق على التوقيع على الموافقة",
  "Patient's reported symptoms…": "الأعراض التي أبلغ عنها المريض…",
  "Patients where you are the attending physician or assigned nurse.": "المرضى الذين أنت طبيبهم المعالج أو الممرض المكلف بهم.",
  "Pending Discharges": "تصاريح خروج معلقة",
  "Pending Home Visits": "زيارات منزلية معلقة",
  "Pending Medical Review": "مراجعات طبية معلقة",
  "Pending Operational Review": "مراجعات تشغيلية معلقة",
  "Pending Teleconsults": "استشارات عن بُعد معلقة",
  "Physician Notified": "تم إخطار الطبيب",
  "Physician Review": "مراجعة الطبيب",
  "Pick a category first": "اختر فئة أولاً",
  "Pick a patient or uncheck 'Include patient'": "اختر مريضاً أو أزل تحديد 'تضمين المريض'",
  "Pre-fills the nurse's decision capture form.": "يملأ نموذج تسجيل قرار الممرض مسبقاً.",
  "Primary diagnosis is required": "التشخيص الأساسي مطلوب",
  "Program has been explained": "تم شرح البرنامج",
  "Provider in mocked mode": "مزود الخدمة في وضع المحاكاة",
  "Provider live": "مزود الخدمة نشط",
  "Publish form": "نشر النموذج",
  "Publish update": "نشر التحديث",
  "Question text": "نص السؤال",
  "RPM Alerts": "تنبيهات RPM",
  "RPM Device Setup": "إعداد جهاز RPM",
  "RPM Escalation": "تصعيد RPM",
  "RPM Intervention": "تدخل RPM",
  "RPM alert": "تنبيه RPM",
  "RPM alerts unacknowledged": "تنبيهات RPM غير مُقرّة",
  "RPM enrollment": "تسجيل في RPM",
  "RPM readiness verification": "التحقق من جاهزية RPM",
  "Reading History": "سجل القراءات",
  "Readmission Pending Approval": "إعادة القبول بانتظار الموافقة",
  "Readmission approved": "تمت الموافقة على إعادة القبول",
  "Readmission requested — sent to physician": "تم طلب إعادة القبول — أُرسل إلى الطبيب",
  "Ready for dispatch": "جاهز للإرسال",
  "Recommendation text": "نص التوصية",
  "Record allergy": "تسجيل الحساسية",
  "Red-tier alerts open": "تنبيهات المستوى الأحمر المفتوحة",
  "Refer to Emergency Dept": "إحالة إلى قسم الطوارئ",
  "Refer to H@H Program": "إحالة إلى برنامج H@H",
  "Register & continue": "تسجيل والمتابعة",
  "Reject readmission": "رفض إعادة القبول",
  "Repeat Reading Requested": "تم طلب إعادة القراءة",
  "Reset & log change": "إعادة الضبط وتسجيل التغيير",
  "Reset to Default": "إعادة الضبط إلى الافتراضي",
  "Resolution Rate": "معدل الحل",
  "Resolved Today": "تم الحل اليوم",
  "Respiratory Therapist": "معالج تنفسي",
  "Retire form": "إيقاف النموذج",
  "Role is required": "الدور مطلوب",
  "Running water available": "المياه الجارية متوفرة",
  "Safe environment": "بيئة آمنة",
  "Save Changes": "حفظ التغييرات",
  "Save draft": "حفظ المسودة",
  "Save vitals": "حفظ العلامات الحيوية",
  "Save with justification": "حفظ مع المبرر",
  "Scheduled or completed today": "مجدول أو مكتمل اليوم",
  "Select interventions and set a frequency for each.": "حدد التدخلات وحدد تكراراً لكل منها.",
  "Select protocol": "اختر البروتوكول",
  "Severe chest pain": "ألم صدري شديد",
  "Show My Tasks": "عرض مهامي",
  "Showing My Tasks": "عرض مهامي",
  "Smartphone available": "الهاتف الذكي متاح",
  "Social Worker": "الأخصائي الاجتماعي",
  "Something went wrong.": "حدث خطأ ما.",
  "Stable band ends here": "تنتهي النطاق المستقر هنا",
  "Stable band starts here": "يبدأ النطاق المستقر هنا",
  "Start Call": "بدء المكالمة",
  "Step 1 of 2 — identify the patient calling in.": "الخطوة 1 من 2 — تحديد هوية المريض المتصل.",
  "Step 2 of 2 — capture chief complaint and start the session.": "الخطوة 2 من 2 — تسجيل الشكوى الرئيسية وبدء الجلسة.",
  "Street, city, region": "الشارع، المدينة، المنطقة",
  "Submit for Review": "إرسال للمراجعة",
  "Suitable bathroom": "حمام مناسب",
  "Suitable bedroom": "غرفة نوم مناسبة",
  "Teleconsultation Scheduled": "تمت جدولة الاستشارة عن بُعد",
  "Teleconsultation referral": "إحالة استشارة عن بُعد",
  "Test Patient": "مريض تجريبي",
  "The request returns to draft so the coordinator can submit it for standard medical review.": "تعود الطلب إلى صيغة المسودة ليتمكن المنسق من إرساله للمراجعة الطبية المعتادة.",
  "The user will be asked to change this on first login.": "سيُطلب من المستخدم تغيير هذا عند تسجيل الدخول لأول مرة.",
  "This patient": "هذا المريض",
  "This will close the workflow. The hospital coordinator will be notified.": "سيؤدي هذا إلى إغلاق سير العمل. سيتم إشعار منسق المستشفى.",
  "Today's Visits": "زيارات اليوم",
  "Tomorrow 09:30 KSA": "غداً 09:30 KSA",
  "Transfer to unit": "نقل إلى الوحدة",
  "Unacknowledged Alerts": "تنبيهات غير مُقرَّة",
  "Unassigned Visits": "زيارات غير مُعيَّنة",
  "Under Medical Review": "قيد المراجعة الطبية",
  "Under Operational Assessment": "قيد التقييم التشغيلي",
  "Unique slug. Cannot change after creation.": "معرّف فريد. لا يمكن تغييره بعد الإنشاء.",
  "Update team name, description, or change the team lead.": "تحديث اسم الفريق أو الوصف أو تغيير قائد الفريق.",
  "Update the user profile, role and assignments.": "تحديث ملف المستخدم والدور والمهام المسندة.",
  "Used to detect returning H@H patients.": "يُستخدم للكشف عن مرضى H@H العائدين.",
  "User Lifecycle": "دورة حياة المستخدم",
  "View a clinician's open 30-minute slots. Booked slots are greyed out.": "عرض الفترات المتاحة لمدة 30 دقيقة للإكلينيكي. الفترات المحجوزة تظهر باللون الرمادي.",
  "View full Care Record": "عرض سجل الرعاية الكامل",
  "Visit Completed": "اكتملت الزيارة",
  "Visit being scheduled.": "جارٍ جدولة الزيارة.",
  "Visit started": "بدأت الزيارة",
  "Vital Trends": "اتجاهات العلامات الحيوية",
  "Waste management assessment": "تقييم إدارة النفايات",
  "Where the form appears for users to fill.": "الموقع الذي يظهر فيه النموذج للمستخدمين لملئه.",
  "Wound Care": "رعاية الجروح",
  "Your assigned in-home visits and findings.": "زياراتك المنزلية المُسندة إليك ونتائجها.",
  "Roles": "الأدوار",
  "Roles and facility assignments. A user can hold multiple roles and belong to multiple facilities.": "تعيينات الأدوار والمنشآت. يمكن للمستخدم أن يحمل أدواراً متعددة وأن ينتمي إلى منشآت متعددة.",
  "Select one or more roles.": "اختر دوراً واحداً أو أكثر.",
  "Select one or more facilities.": "اختر منشأة واحدة أو أكثر.",
  "At least one role is required": "مطلوب دور واحد على الأقل",
  "Clinical": "إكلينيكي",
  "Identity": "الهوية",
  "Nationality and government identity. Identity type must be selected before the identity number.": "الجنسية والهوية الحكومية. يجب اختيار نوع الهوية قبل إدخال رقم الهوية.",
  "Nationality": "الجنسية",
  "Select nationality": "اختر الجنسية",
  "Identity type": "نوع الهوية",
  "Locked to National Number for Saudi nationals.": "مثبّت على رقم وطني للمواطنين السعوديين.",
  "Select before entering the identity number.": "اختر قبل إدخال رقم الهوية.",
  "Select identity type": "اختر نوع الهوية",
  "Identity number": "رقم الهوية",
  "Must start with 1 and be exactly 10 digits.": "يجب أن يبدأ بالرقم 1 وأن يتكون من 10 أرقام بالضبط.",
  "Unique across the platform.": "فريد على مستوى المنصة.",
  "Select identity type first": "اختر نوع الهوية أولاً",
  "Professional Details": "التفاصيل المهنية",
  "Required for physicians and nurses.": "مطلوب للأطباء والممرضين.",
  "License number": "رقم الترخيص",
  "License expiry date": "تاريخ انتهاء الترخيص",
  "Specialty type": "نوع التخصص",
  "Select specialty type": "اختر نوع التخصص",
  "Medical specialization": "التخصص الطبي",
  "Select specialization": "اختر التخصص",
  "Sub specialty": "التخصص الفرعي",
  "Select a medical specialization first.": "اختر التخصص الطبي أولاً.",
  "Select sub specialty": "اختر التخصص الفرعي",
  "Second name": "الاسم الأوسط",
  "Optional middle name.": "الاسم الأوسط (اختياري).",
  "Gender": "الجنس",
  "Select gender": "اختر الجنس",
  "Male": "ذكر",
  "Female": "أنثى",
  "Other": "آخر",
  "Date of birth": "تاريخ الميلاد",
  "Future dates are not allowed.": "لا يُسمح بتواريخ مستقبلية.",
  "Date of birth cannot be in the future": "لا يمكن أن يكون تاريخ الميلاد في المستقبل",
  "Date of birth is required": "تاريخ الميلاد مطلوب",
  "Gender is required": "الجنس مطلوب",
  "Nationality is required": "الجنسية مطلوبة",
  "Years of experience": "سنوات الخبرة",
  "Years of experience is required": "سنوات الخبرة مطلوبة",
  "Enter a whole number between 0 and 70": "أدخل رقماً صحيحاً بين 0 و70",
  "Select the dial code first, then enter the number.": "اختر رمز الاتصال أولاً ثم أدخل الرقم.",
  "Select dial code first": "اختر رمز الاتصال أولاً",
  "Select a dial code before entering the phone number": "اختر رمز الاتصال قبل إدخال رقم الهاتف",
  "Phone number": "رقم الهاتف",
  "Alternate contact number": "رقم اتصال بديل",
  "Alternate contact number (optional)": "رقم اتصال بديل (اختياري)",
  "Optional secondary contact.": "جهة اتصال ثانوية اختيارية.",
  "Select a dial code for the alternate number": "اختر رمز الاتصال للرقم البديل",
  "Alternate number": "الرقم البديل",
  "Code": "الرمز",
  "Optional": "اختياري",
  "Government identity. Identity type must be selected before the identity number.": "الهوية الحكومية. يجب اختيار نوع الهوية قبل رقم الهوية.",
  "Please fix the highlighted fields before saving.": "يرجى تصحيح الحقول المظللة قبل الحفظ.",
  "Enter a valid email address": "أدخل عنوان بريد إلكتروني صالحاً",
  "Demographic Data": "البيانات الديموغرافية",
  "Full name": "الاسم الكامل",
  "System generated.": "يُنشأ تلقائياً بواسطة النظام.",
  "Auto-generated on save.": "يُنشأ تلقائياً عند الحفظ.",
  "Identity number": "رقم الهوية",
  "Select identity type first": "اختر نوع الهوية أولاً",
  "Location address": "العنوان",
  "Postal code": "الرمز البريدي",
  "Emergency Contact": "جهة اتصال الطوارئ",
  "Primary contact in case of emergency.": "جهة الاتصال الأساسية في حالة الطوارئ.",
  "Clinical Data": "البيانات السريرية",
  "Special needs": "الاحتياجات الخاصة",
  "Allergies": "الحساسية",
  "Special needs, allergies and accommodation.": "الاحتياجات الخاصة والحساسية والتيسيرات.",
  "Multi-select. Defaults to N/A if none.": "اختيار متعدد. القيمة الافتراضية غير متوفر إن لم يُحدد شيء.",
  "Language": "اللغة",
  "Select language": "اختر اللغة",
  "English": "الإنجليزية",
  "Arabic": "العربية",
  "Requires interpreter": "يحتاج إلى مترجم",
  "Must be at least 20 years; no future dates.": "يجب أن يكون 20 عاماً على الأقل؛ لا تواريخ مستقبلية.",
  "Select the country dial code first.": "اختر رمز اتصال الدولة أولاً.",
  "Select a country dial code first": "اختر رمز اتصال الدولة أولاً",
  "Patient should be at least 20 years of age": "يجب أن يكون عمر المريض 20 عاماً على الأقل",
  "Starts with 1, 10 digits.": "يبدأ بالرقم 1، 10 أرقام.",
  "Starts with 2, 10 digits.": "يبدأ بالرقم 2، 10 أرقام.",
  "10 digits starting with 3 or 4.": "10 أرقام تبدأ بالرقم 3 أو 4.",
  "5–30, letters + numbers.": "من 5 إلى 30، حروف وأرقام.",
  "Patient created": "تم إنشاء المريض",
  "Patient updated": "تم تحديث المريض",
  "Yes": "نعم",
  "No": "لا",
};

export default AR;
